import { jsx as ye, jsxs as Fe } from "react/jsx-runtime";
import { Input as ci } from "../ui/input.js";
import kn from "../../store/useStore.js";
import v, { useRef as cr, useState as di, useEffect as fs, useMemo as dr } from "react";
import { PRIORITY_TOKEN_IDS as In, CARDANO_TOKEN as Ke } from "../../swap/components/tokens.js";
import { formatBalance as hs } from "../../utils/formatNumber.js";
import { R as fi } from "../../index-c8f2666b.js";
import { TokenImage as ms } from "./TokenImage.js";
import { server as Mn } from "../../config/axios.js";
import { cn as hi } from "../../lib/utils.js";
import mi from "../../hooks/useScreen.js";
import pi from "../../assets/svg/IconRemove.js";
import gi from "../ui/tooltipDialog.js";
import { getBalance as _i } from "../../utils/cardanoUtils.js";
import yi from "../../hooks/useGlobalSettings.js";
import Si from "../../assets/svg/IconWallet.js";
import wi from "../../assets/svg/IconWalletCross.js";
import vi from "../../assets/svg/IconMagnifier.js";
import { Sheet as xi, SheetContent as Ti } from "../ui/sheet-connect-wallet.js";
import { u as tn } from "../../useQuery-714c7c61.js";
import { I as ki } from "../../IconTilde-bf643edd.js";
import "../../lib.js";
import "../../extend-tailwind-merge-e63b2b56.js";
import "../../_commonjsHelpers-10dfc225.js";
import "../../index-9d43cc8b.js";
import "../../store/createTokenSearchSlice.js";
import "../../immer-548168ec.js";
import "../../store/createWalletSlice.js";
import "../../store/createSwapSettingsSlice.js";
import "../../store/createGlobalSettingsSlice.js";
import "../../store/createUserOrdersSlice.js";
import "../../store/createSwapSlice.js";
import "../../store/createChartSlice.js";
import "../../store/createBasketSlice.js";
import "../../store/createModalWhatsNewSlice.js";
import "../../store/createSwapParamsSlice.js";
import "../../index-1c873780.js";
import "../ui/skeleton.js";
import "../../index-ca8eb9e1.js";
import "../../axios-ddd885c5.js";
import "../../config/decrypt.js";
import "../ui/dialog.js";
import "../../index-840f2930.js";
import "../../index-c7156e07.js";
import "../../index-563d1ed8.js";
import "../../index-4914f99c.js";
import "../../index-67500cd3.js";
import "../../index-27cadef5.js";
import "../../index-5116e957.js";
import "../ui/tooltip.js";
import "../../index-0ce202b9.js";
import "../../index-bcfeaad9.js";
import "../../index-f7426637.js";
import "../../index-1d6812f7.js";
import "../../QueryClientProvider-103c6f38.js";
import "../../notifyManager-b5b16d35.js";
import "../../createReactComponent-ec43b511.js";
const $n = 0, Ct = 1, Jt = 2, Fs = 4;
function As(e, t) {
  return (n) => e(t(n));
}
function Ii(e, t) {
  return t(e);
}
function Vs(e, t) {
  return (n) => e(t, n);
}
function ps(e, t) {
  return () => e(t);
}
function jn(e, t) {
  return t(e), e;
}
function me(...e) {
  return e;
}
function Mi(e) {
  e();
}
function gs(e) {
  return () => e;
}
function Di(...e) {
  return () => {
    e.map(Mi);
  };
}
function Yr(e) {
  return e !== void 0;
}
function Qt() {
}
function ae(e, t) {
  return e(Ct, t);
}
function $(e, t) {
  e($n, t);
}
function Er(e) {
  e(Jt);
}
function Ue(e) {
  return e(Fs);
}
function H(e, t) {
  return ae(e, Vs(t, $n));
}
function _t(e, t) {
  const n = e(Ct, (r) => {
    n(), t(r);
  });
  return n;
}
function ee() {
  const e = [];
  return (t, n) => {
    switch (t) {
      case Jt:
        e.splice(0, e.length);
        return;
      case Ct:
        return e.push(n), () => {
          const r = e.indexOf(n);
          r > -1 && e.splice(r, 1);
        };
      case $n:
        e.slice().forEach((r) => {
          r(n);
        });
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function k(e) {
  let t = e;
  const n = ee();
  return (r, s) => {
    switch (r) {
      case Ct:
        s(t);
        break;
      case $n:
        t = s;
        break;
      case Fs:
        return t;
    }
    return n(r, s);
  };
}
function bi(e) {
  let t, n;
  const r = () => t && t();
  return function(s, o) {
    switch (s) {
      case Ct:
        return o ? n === o ? void 0 : (r(), n = o, t = ae(e, o), t) : (r(), Qt);
      case Jt:
        r(), n = null;
        return;
      default:
        throw new Error(`unrecognized action ${s}`);
    }
  };
}
function Ge(e) {
  return jn(ee(), (t) => H(e, t));
}
function Ce(e, t) {
  return jn(k(t), (n) => H(e, n));
}
function Oi(...e) {
  return (t) => e.reduceRight(Ii, t);
}
function y(e, ...t) {
  const n = Oi(...t);
  return (r, s) => {
    switch (r) {
      case Ct:
        return ae(e, n(s));
      case Jt:
        Er(e);
        return;
    }
  };
}
function Us(e, t) {
  return e === t;
}
function he(e = Us) {
  let t;
  return (n) => (r) => {
    e(t, r) || (t = r, n(r));
  };
}
function V(e) {
  return (t) => (n) => {
    e(n) && t(n);
  };
}
function R(e) {
  return (t) => As(t, e);
}
function ht(e) {
  return (t) => () => t(e);
}
function ot(e, t) {
  return (n) => (r) => n(t = e(t, r));
}
function Kt(e) {
  return (t) => (n) => {
    e > 0 ? e-- : t(n);
  };
}
function It(e) {
  let t = null, n;
  return (r) => (s) => {
    t = s, !n && (n = setTimeout(() => {
      n = void 0, r(t);
    }, e));
  };
}
function _s(e) {
  let t, n;
  return (r) => (s) => {
    t = s, n && clearTimeout(n), n = setTimeout(() => {
      r(t);
    }, e);
  };
}
function q(...e) {
  const t = new Array(e.length);
  let n = 0, r = null;
  const s = Math.pow(2, e.length) - 1;
  return e.forEach((o, i) => {
    const a = Math.pow(2, i);
    ae(o, (l) => {
      const u = n;
      n = n | a, t[i] = l, u !== s && n === s && r && (r(), r = null);
    });
  }), (o) => (i) => {
    const a = () => o([i].concat(t));
    n === s ? a() : r = a;
  };
}
function ys(...e) {
  return function(t, n) {
    switch (t) {
      case Ct:
        return Di(...e.map((r) => ae(r, n)));
      case Jt:
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function A(e, t = Us) {
  return y(e, he(t));
}
function ke(...e) {
  const t = ee(), n = new Array(e.length);
  let r = 0;
  const s = Math.pow(2, e.length) - 1;
  return e.forEach((o, i) => {
    const a = Math.pow(2, i);
    ae(o, (l) => {
      n[i] = l, r = r | a, r === s && $(t, n);
    });
  }), function(o, i) {
    switch (o) {
      case Ct:
        return r === s && i(n), ae(t, i);
      case Jt:
        return Er(t);
      default:
        throw new Error(`unrecognized action ${o}`);
    }
  };
}
function oe(e, t = [], { singleton: n } = { singleton: !0 }) {
  return {
    id: Ci(),
    constructor: e,
    dependencies: t,
    singleton: n
  };
}
const Ci = () => Symbol();
function Ri(e) {
  const t = /* @__PURE__ */ new Map(), n = ({ id: r, constructor: s, dependencies: o, singleton: i }) => {
    if (i && t.has(r))
      return t.get(r);
    const a = s(o.map((l) => n(l)));
    return i && t.set(r, a), a;
  };
  return n(e);
}
function Yi(e, t) {
  const n = {}, r = {};
  let s = 0;
  const o = e.length;
  for (; s < o; )
    r[e[s]] = 1, s += 1;
  for (const i in t)
    r.hasOwnProperty(i) || (n[i] = t[i]);
  return n;
}
const Dn = typeof document < "u" ? v.useLayoutEffect : v.useEffect;
function Gs(e, t, n) {
  const r = Object.keys(t.required || {}), s = Object.keys(t.optional || {}), o = Object.keys(t.methods || {}), i = Object.keys(t.events || {}), a = v.createContext({});
  function l(d, x) {
    d.propsReady && $(d.propsReady, !1);
    for (const h of r) {
      const m = d[t.required[h]];
      $(m, x[h]);
    }
    for (const h of s)
      if (h in x) {
        const m = d[t.optional[h]];
        $(m, x[h]);
      }
    d.propsReady && $(d.propsReady, !0);
  }
  function u(d) {
    return o.reduce((x, h) => (x[h] = (m) => {
      const T = d[t.methods[h]];
      $(T, m);
    }, x), {});
  }
  function c(d) {
    return i.reduce((x, h) => (x[h] = bi(d[t.events[h]]), x), {});
  }
  return {
    Component: v.forwardRef((d, x) => {
      const { children: h, ...m } = d, [T] = v.useState(() => jn(Ri(e), (g) => l(g, m))), [Y] = v.useState(ps(c, T));
      return Dn(() => {
        for (const g of i)
          g in m && ae(Y[g], m[g]);
        return () => {
          Object.values(Y).map(Er);
        };
      }, [m, Y, T]), Dn(() => {
        l(T, m);
      }), v.useImperativeHandle(x, gs(u(T))), v.createElement(
        a.Provider,
        { value: T },
        n ? v.createElement(
          n,
          Yi([...r, ...s, ...i], m),
          h
        ) : h
      );
    }),
    usePublisher: (d) => v.useCallback(Vs($, v.useContext(a)[d]), [d]),
    useEmitterValue: (d) => {
      const h = v.useContext(a)[d], [m, T] = v.useState(ps(Ue, h));
      return Dn(
        () => ae(h, (Y) => {
          Y !== m && T(gs(Y));
        }),
        [h, m]
      ), m;
    },
    useEmitter: (d, x) => {
      const m = v.useContext(a)[d];
      Dn(() => ae(m, x), [x, m]);
    }
  };
}
const Ei = typeof document < "u" ? v.useLayoutEffect : v.useEffect, Ni = Ei;
var ze = /* @__PURE__ */ ((e) => (e[e.DEBUG = 0] = "DEBUG", e[e.INFO = 1] = "INFO", e[e.WARN = 2] = "WARN", e[e.ERROR = 3] = "ERROR", e))(ze || {});
const Pi = {
  0: "debug",
  1: "log",
  2: "warn",
  3: "error"
}, Li = () => typeof globalThis > "u" ? window : globalThis, Rt = oe(
  () => {
    const e = k(
      3
      /* ERROR */
    );
    return {
      log: k((n, r, s = 1) => {
        var o;
        const i = (o = Li().VIRTUOSO_LOG_LEVEL) != null ? o : Ue(e);
        s >= i && console[Pi[s]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          n,
          r
        );
      }),
      logLevel: e
    };
  },
  [],
  { singleton: !0 }
);
function Nr(e, t = !0) {
  const n = v.useRef(null);
  let r = (s) => {
  };
  if (typeof ResizeObserver < "u") {
    const s = v.useMemo(() => new ResizeObserver((o) => {
      const i = o[0].target;
      i.offsetParent !== null && e(i);
    }), [e]);
    r = (o) => {
      o && t ? (s.observe(o), n.current = o) : (n.current && s.unobserve(n.current), n.current = null);
    };
  }
  return { ref: n, callbackRef: r };
}
function Ft(e, t = !0) {
  return Nr(e, t).callbackRef;
}
function Hi(e, t, n, r, s, o, i) {
  const a = v.useCallback(
    (l) => {
      const u = Wi(l.children, t, "offsetHeight", s);
      let c = l.parentElement;
      for (; !c.dataset.virtuosoScroller; )
        c = c.parentElement;
      const p = c.lastElementChild.dataset.viewportType === "window", _ = i ? i.scrollTop : p ? window.pageYOffset || document.documentElement.scrollTop : c.scrollTop, D = i ? i.scrollHeight : p ? document.documentElement.scrollHeight : c.scrollHeight, M = i ? i.offsetHeight : p ? window.innerHeight : c.offsetHeight;
      r({
        scrollTop: Math.max(_, 0),
        scrollHeight: D,
        viewportHeight: M
      }), o == null || o(Fi("row-gap", getComputedStyle(l).rowGap, s)), u !== null && e(u);
    },
    [e, t, s, o, i, r]
  );
  return Nr(a, n);
}
function Wi(e, t, n, r) {
  const s = e.length;
  if (s === 0)
    return null;
  const o = [];
  for (let i = 0; i < s; i++) {
    const a = e.item(i);
    if (!a || a.dataset.index === void 0)
      continue;
    const l = parseInt(a.dataset.index), u = parseFloat(a.dataset.knownSize), c = t(a, n);
    if (c === 0 && r("Zero-sized element, this should not happen", { child: a }, ze.ERROR), c === u)
      continue;
    const p = o[o.length - 1];
    o.length === 0 || p.size !== c || p.endIndex !== l - 1 ? o.push({ startIndex: l, endIndex: l, size: c }) : o[o.length - 1].endIndex++;
  }
  return o;
}
function Fi(e, t, n) {
  return t !== "normal" && !(t != null && t.endsWith("px")) && n(`${e} was not resolved to pixel value correctly`, t, ze.WARN), t === "normal" ? 0 : parseInt(t ?? "0", 10);
}
function Ot(e, t) {
  return Math.round(e.getBoundingClientRect()[t]);
}
function zs(e, t) {
  return Math.abs(e - t) < 1.01;
}
function Bs(e, t, n, r = Qt, s) {
  const o = v.useRef(null), i = v.useRef(null), a = v.useRef(null), l = v.useCallback(
    (p) => {
      const _ = p.target, D = _ === window || _ === document, M = D ? window.pageYOffset || document.documentElement.scrollTop : _.scrollTop, d = D ? document.documentElement.scrollHeight : _.scrollHeight, x = D ? window.innerHeight : _.offsetHeight, h = () => {
        e({
          scrollTop: Math.max(M, 0),
          scrollHeight: d,
          viewportHeight: x
        });
      };
      p.suppressFlushSync ? h() : fi.flushSync(h), i.current !== null && (M === i.current || M <= 0 || M === d - x) && (i.current = null, t(!0), a.current && (clearTimeout(a.current), a.current = null));
    },
    [e, t]
  );
  v.useEffect(() => {
    const p = s || o.current;
    return r(s || o.current), l({ target: p, suppressFlushSync: !0 }), p.addEventListener("scroll", l, { passive: !0 }), () => {
      r(null), p.removeEventListener("scroll", l);
    };
  }, [o, l, n, r, s]);
  function u(p) {
    const _ = o.current;
    if (!_ || "offsetHeight" in _ && _.offsetHeight === 0)
      return;
    const D = p.behavior === "smooth";
    let M, d, x;
    _ === window ? (d = Math.max(Ot(document.documentElement, "height"), document.documentElement.scrollHeight), M = window.innerHeight, x = document.documentElement.scrollTop) : (d = _.scrollHeight, M = Ot(_, "height"), x = _.scrollTop);
    const h = d - M;
    if (p.top = Math.ceil(Math.max(Math.min(h, p.top), 0)), zs(M, d) || p.top === x) {
      e({ scrollTop: x, scrollHeight: d, viewportHeight: M }), D && t(!0);
      return;
    }
    D ? (i.current = p.top, a.current && clearTimeout(a.current), a.current = setTimeout(() => {
      a.current = null, i.current = null, t(!0);
    }, 1e3)) : i.current = null, _.scrollTo(p);
  }
  function c(p) {
    o.current.scrollBy(p);
  }
  return { scrollerRef: o, scrollByCallback: c, scrollToCallback: u };
}
const Re = oe(
  () => {
    const e = ee(), t = ee(), n = k(0), r = ee(), s = k(0), o = ee(), i = ee(), a = k(0), l = k(0), u = k(0), c = k(0), p = ee(), _ = ee(), D = k(!1);
    return H(
      y(
        e,
        R(({ scrollTop: M }) => M)
      ),
      t
    ), H(
      y(
        e,
        R(({ scrollHeight: M }) => M)
      ),
      i
    ), H(t, s), {
      // input
      scrollContainerState: e,
      scrollTop: t,
      viewportHeight: o,
      headerHeight: a,
      fixedHeaderHeight: l,
      fixedFooterHeight: u,
      footerHeight: c,
      scrollHeight: i,
      smoothScrollTargetReached: r,
      // signals
      scrollTo: p,
      scrollBy: _,
      // state
      statefulScrollTop: s,
      deviation: n,
      scrollingInProgress: D
    };
  },
  [],
  { singleton: !0 }
), un = { lvl: 0 };
function $s(e, t, n, r = un, s = un) {
  return { k: e, v: t, lvl: n, l: r, r: s };
}
function ue(e) {
  return e === un;
}
function $t() {
  return un;
}
function wr(e, t) {
  if (ue(e))
    return un;
  const { k: n, l: r, r: s } = e;
  if (t === n) {
    if (ue(r))
      return s;
    if (ue(s))
      return r;
    {
      const [o, i] = js(r);
      return Rn(ve(e, { k: o, v: i, l: Zs(r) }));
    }
  } else
    return t < n ? Rn(ve(e, { l: wr(r, t) })) : Rn(ve(e, { r: wr(s, t) }));
}
function cn(e, t) {
  if (!ue(e))
    return t === e.k ? e.v : t < e.k ? cn(e.l, t) : cn(e.r, t);
}
function Xe(e, t, n = "k") {
  if (ue(e))
    return [-1 / 0, void 0];
  if (Number(e[n]) === t)
    return [e.k, e.v];
  if (Number(e[n]) < t) {
    const r = Xe(e.r, t, n);
    return r[0] === -1 / 0 ? [e.k, e.v] : r;
  }
  return Xe(e.l, t, n);
}
function Ve(e, t, n) {
  return ue(e) ? $s(t, n, 1) : t === e.k ? ve(e, { k: t, v: n }) : t < e.k ? Ss(ve(e, { l: Ve(e.l, t, n) })) : Ss(ve(e, { r: Ve(e.r, t, n) }));
}
function vr(e, t, n) {
  if (ue(e))
    return [];
  const { k: r, v: s, l: o, r: i } = e;
  let a = [];
  return r > t && (a = a.concat(vr(o, t, n))), r >= t && r <= n && a.push({ k: r, v: s }), r <= n && (a = a.concat(vr(i, t, n))), a;
}
function Lt(e) {
  return ue(e) ? [] : [...Lt(e.l), { k: e.k, v: e.v }, ...Lt(e.r)];
}
function js(e) {
  return ue(e.r) ? [e.k, e.v] : js(e.r);
}
function Zs(e) {
  return ue(e.r) ? e.l : Rn(ve(e, { r: Zs(e.r) }));
}
function ve(e, t) {
  return $s(
    t.k !== void 0 ? t.k : e.k,
    t.v !== void 0 ? t.v : e.v,
    t.lvl !== void 0 ? t.lvl : e.lvl,
    t.l !== void 0 ? t.l : e.l,
    t.r !== void 0 ? t.r : e.r
  );
}
function fr(e) {
  return ue(e) || e.lvl > e.r.lvl;
}
function Ss(e) {
  return xr(Ks(e));
}
function Rn(e) {
  const { l: t, r: n, lvl: r } = e;
  if (n.lvl >= r - 1 && t.lvl >= r - 1)
    return e;
  if (r > n.lvl + 1) {
    if (fr(t))
      return Ks(ve(e, { lvl: r - 1 }));
    if (!ue(t) && !ue(t.r))
      return ve(t.r, {
        l: ve(t, { r: t.r.l }),
        r: ve(e, {
          l: t.r.r,
          lvl: r - 1
        }),
        lvl: r
      });
    throw new Error("Unexpected empty nodes");
  } else {
    if (fr(e))
      return xr(ve(e, { lvl: r - 1 }));
    if (!ue(n) && !ue(n.l)) {
      const s = n.l, o = fr(s) ? n.lvl - 1 : n.lvl;
      return ve(s, {
        l: ve(e, {
          r: s.l,
          lvl: r - 1
        }),
        r: xr(ve(n, { l: s.r, lvl: o })),
        lvl: s.lvl + 1
      });
    } else
      throw new Error("Unexpected empty nodes");
  }
}
function Zn(e, t, n) {
  if (ue(e))
    return [];
  const r = Xe(e, t)[0];
  return Ai(vr(e, r, n));
}
function qs(e, t) {
  const n = e.length;
  if (n === 0)
    return [];
  let { index: r, value: s } = t(e[0]);
  const o = [];
  for (let i = 1; i < n; i++) {
    const { index: a, value: l } = t(e[i]);
    o.push({ start: r, end: a - 1, value: s }), r = a, s = l;
  }
  return o.push({ start: r, end: 1 / 0, value: s }), o;
}
function Ai(e) {
  return qs(e, ({ k: t, v: n }) => ({ index: t, value: n }));
}
function xr(e) {
  const { r: t, lvl: n } = e;
  return !ue(t) && !ue(t.r) && t.lvl === n && t.r.lvl === n ? ve(t, { l: ve(e, { r: t.l }), lvl: n + 1 }) : e;
}
function Ks(e) {
  const { l: t } = e;
  return !ue(t) && t.lvl === e.lvl ? ve(t, { r: ve(e, { l: t.r }) }) : e;
}
function Ln(e, t, n, r = 0) {
  let s = e.length - 1;
  for (; r <= s; ) {
    const o = Math.floor((r + s) / 2), i = e[o], a = n(i, t);
    if (a === 0)
      return o;
    if (a === -1) {
      if (s - r < 2)
        return o - 1;
      s = o - 1;
    } else {
      if (s === r)
        return o;
      r = o + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${e.join(",")}, searched for ${t}`);
}
function Js(e, t, n) {
  return e[Ln(e, t, n)];
}
function Vi(e, t, n, r) {
  const s = Ln(e, t, r), o = Ln(e, n, r, s);
  return e.slice(s, o + 1);
}
const Pr = oe(
  () => ({ recalcInProgress: k(!1) }),
  [],
  { singleton: !0 }
);
function Ui(e) {
  const { size: t, startIndex: n, endIndex: r } = e;
  return (s) => s.start === n && (s.end === r || s.end === 1 / 0) && s.value === t;
}
function ws(e, t) {
  let n = 0, r = 0;
  for (; n < e; )
    n += t[r + 1] - t[r] - 1, r++;
  return r - (n === e ? 0 : 1);
}
function Gi(e, t) {
  let n = ue(e) ? 0 : 1 / 0;
  for (const r of t) {
    const { size: s, startIndex: o, endIndex: i } = r;
    if (n = Math.min(n, o), ue(e)) {
      e = Ve(e, 0, s);
      continue;
    }
    const a = Zn(e, o - 1, i + 1);
    if (a.some(Ui(r)))
      continue;
    let l = !1, u = !1;
    for (const { start: c, end: p, value: _ } of a)
      l ? (i >= c || s === _) && (e = wr(e, c)) : (u = _ !== s, l = !0), p > i && i >= c && _ !== s && (e = Ve(e, i + 1, _));
    u && (e = Ve(e, o, s));
  }
  return [e, n];
}
function zi() {
  return {
    offsetTree: [],
    sizeTree: $t(),
    groupOffsetTree: $t(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    groupIndices: []
  };
}
function Lr({ index: e }, t) {
  return t === e ? 0 : t < e ? -1 : 1;
}
function Bi({ offset: e }, t) {
  return t === e ? 0 : t < e ? -1 : 1;
}
function $i(e) {
  return { index: e.index, value: e };
}
function ji(e, t, n, r = 0) {
  return r > 0 && (t = Math.max(t, Js(e, r, Lr).offset)), qs(Vi(e, t, n, Bi), $i);
}
function Tr(e, t, n, r) {
  let s = e, o = 0, i = 0, a = 0, l = 0;
  if (t !== 0) {
    l = Ln(s, t - 1, Lr), a = s[l].offset;
    const c = Xe(n, t - 1);
    o = c[0], i = c[1], s.length && s[l].size === Xe(n, t)[1] && (l -= 1), s = s.slice(0, l + 1);
  } else
    s = [];
  for (const { start: u, value: c } of Zn(n, t, 1 / 0)) {
    const p = u - o, _ = p * i + a + p * r;
    s.push({
      offset: _,
      size: c,
      index: u
    }), o = u, a = _, i = c;
  }
  return {
    offsetTree: s,
    lastIndex: o,
    lastOffset: a,
    lastSize: i
  };
}
function Zi(e, [t, n, r, s]) {
  t.length > 0 && r("received item sizes", t, ze.DEBUG);
  const o = e.sizeTree;
  let i = o, a = 0;
  if (n.length > 0 && ue(o) && t.length === 2) {
    const _ = t[0].size, D = t[1].size;
    i = n.reduce((M, d) => Ve(Ve(M, d, _), d + 1, D), i);
  } else
    [i, a] = Gi(i, t);
  if (i === o)
    return e;
  const { offsetTree: l, lastIndex: u, lastSize: c, lastOffset: p } = Tr(e.offsetTree, a, i, s);
  return {
    sizeTree: i,
    offsetTree: l,
    lastIndex: u,
    lastOffset: p,
    lastSize: c,
    groupOffsetTree: n.reduce((_, D) => Ve(_, D, dn(D, l, s)), $t()),
    groupIndices: n
  };
}
function dn(e, t, n) {
  if (t.length === 0)
    return 0;
  const { offset: r, index: s, size: o } = Js(t, e, Lr), i = e - s, a = o * i + (i - 1) * n + r;
  return a > 0 ? a + n : a;
}
function qi(e) {
  return typeof e.groupIndex < "u";
}
function Qs(e, t, n) {
  if (qi(e))
    return t.groupIndices[e.groupIndex] + 1;
  {
    const r = e.index === "LAST" ? n : e.index;
    let s = Xs(r, t);
    return s = Math.max(0, s, Math.min(n, s)), s;
  }
}
function Xs(e, t) {
  if (!qn(t))
    return e;
  let n = 0;
  for (; t.groupIndices[n] <= e + n; )
    n++;
  return e + n;
}
function qn(e) {
  return !ue(e.groupOffsetTree);
}
function Ki(e) {
  return Lt(e).map(({ k: t, v: n }, r, s) => {
    const o = s[r + 1], i = o ? o.k - 1 : 1 / 0;
    return { startIndex: t, endIndex: i, size: n };
  });
}
const Ji = {
  offsetHeight: "height",
  offsetWidth: "width"
}, at = oe(
  ([{ log: e }, { recalcInProgress: t }]) => {
    const n = ee(), r = ee(), s = Ce(r, 0), o = ee(), i = ee(), a = k(0), l = k([]), u = k(void 0), c = k(void 0), p = k((g, f) => Ot(g, Ji[f])), _ = k(void 0), D = k(0), M = zi(), d = Ce(
      y(n, q(l, e, D), ot(Zi, M), he()),
      M
    ), x = Ce(
      y(
        l,
        he(),
        ot((g, f) => ({ prev: g.current, current: f }), {
          prev: [],
          current: []
        }),
        R(({ prev: g }) => g)
      ),
      []
    );
    H(
      y(
        l,
        V((g) => g.length > 0),
        q(d, D),
        R(([g, f, b]) => {
          const E = g.reduce((P, W, U) => Ve(P, W, dn(W, f.offsetTree, b) || U), $t());
          return {
            ...f,
            groupIndices: g,
            groupOffsetTree: E
          };
        })
      ),
      d
    ), H(
      y(
        r,
        q(d),
        V(([g, { lastIndex: f }]) => g < f),
        R(([g, { lastIndex: f, lastSize: b }]) => [
          {
            startIndex: g,
            endIndex: f,
            size: b
          }
        ])
      ),
      n
    ), H(u, c);
    const h = Ce(
      y(
        u,
        R((g) => g === void 0)
      ),
      !0
    );
    H(
      y(
        c,
        V((g) => g !== void 0 && ue(Ue(d).sizeTree)),
        R((g) => [{ startIndex: 0, endIndex: 0, size: g }])
      ),
      n
    );
    const m = Ge(
      y(
        n,
        q(d),
        ot(
          ({ sizes: g }, [f, b]) => ({
            changed: b !== g,
            sizes: b
          }),
          { changed: !1, sizes: M }
        ),
        R((g) => g.changed)
      )
    );
    ae(
      y(
        a,
        ot(
          (g, f) => ({ diff: g.prev - f, prev: f }),
          { diff: 0, prev: 0 }
        ),
        R((g) => g.diff)
      ),
      (g) => {
        const { groupIndices: f } = Ue(d);
        if (g > 0)
          $(t, !0), $(o, g + ws(g, f));
        else if (g < 0) {
          const b = Ue(x);
          b.length > 0 && (g -= ws(-g, b)), $(i, g);
        }
      }
    ), ae(y(a, q(e)), ([g, f]) => {
      g < 0 && f(
        "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
        { firstItemIndex: a },
        ze.ERROR
      );
    });
    const T = Ge(o);
    H(
      y(
        o,
        q(d),
        R(([g, f]) => {
          const b = f.groupIndices.length > 0, E = [], P = f.lastSize;
          if (b) {
            const W = cn(f.sizeTree, 0);
            let U = 0, K = 0;
            for (; U < g; ) {
              const G = f.groupIndices[K], se = f.groupIndices.length === K + 1 ? 1 / 0 : f.groupIndices[K + 1] - G - 1;
              E.push({
                startIndex: G,
                endIndex: G,
                size: W
              }), E.push({
                startIndex: G + 1,
                endIndex: G + 1 + se - 1,
                size: P
              }), K++, U += se + 1;
            }
            const ie = Lt(f.sizeTree);
            return U !== g && ie.shift(), ie.reduce(
              (G, { k: se, v: _e }) => {
                let Ye = G.ranges;
                return G.prevSize !== 0 && (Ye = [
                  ...G.ranges,
                  {
                    startIndex: G.prevIndex,
                    endIndex: se + g - 1,
                    size: G.prevSize
                  }
                ]), {
                  ranges: Ye,
                  prevIndex: se + g,
                  prevSize: _e
                };
              },
              {
                ranges: E,
                prevIndex: g,
                prevSize: 0
              }
            ).ranges;
          }
          return Lt(f.sizeTree).reduce(
            (W, { k: U, v: K }) => ({
              ranges: [...W.ranges, { startIndex: W.prevIndex, endIndex: U + g - 1, size: W.prevSize }],
              prevIndex: U + g,
              prevSize: K
            }),
            {
              ranges: [],
              prevIndex: 0,
              prevSize: P
            }
          ).ranges;
        })
      ),
      n
    );
    const Y = Ge(
      y(
        i,
        q(d, D),
        R(([g, { offsetTree: f }, b]) => {
          const E = -g;
          return dn(E, f, b);
        })
      )
    );
    return H(
      y(
        i,
        q(d, D),
        R(([g, f, b]) => {
          if (f.groupIndices.length > 0) {
            if (ue(f.sizeTree))
              return f;
            let P = $t();
            const W = Ue(x);
            let U = 0, K = 0, ie = 0;
            for (; U < -g; ) {
              ie = W[K];
              const G = W[K + 1] - ie - 1;
              K++, U += G + 1;
            }
            if (P = Lt(f.sizeTree).reduce((G, { k: se, v: _e }) => Ve(G, Math.max(0, se + g), _e), P), U !== -g) {
              const G = cn(f.sizeTree, ie);
              P = Ve(P, 0, G);
              const se = Xe(f.sizeTree, -g + 1)[1];
              P = Ve(P, 1, se);
            }
            return {
              ...f,
              sizeTree: P,
              ...Tr(f.offsetTree, 0, P, b)
            };
          } else {
            const P = Lt(f.sizeTree).reduce((W, { k: U, v: K }) => Ve(W, Math.max(0, U + g), K), $t());
            return {
              ...f,
              sizeTree: P,
              ...Tr(f.offsetTree, 0, P, b)
            };
          }
        })
      ),
      d
    ), {
      // input
      data: _,
      totalCount: r,
      sizeRanges: n,
      groupIndices: l,
      defaultItemSize: c,
      fixedItemSize: u,
      unshiftWith: o,
      shiftWith: i,
      shiftWithOffset: Y,
      beforeUnshiftWith: T,
      firstItemIndex: a,
      gap: D,
      // output
      sizes: d,
      listRefresh: m,
      statefulTotalCount: s,
      trackItemSizes: h,
      itemSize: p
    };
  },
  me(Rt, Pr),
  { singleton: !0 }
), Qi = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function eo(e) {
  const t = typeof e == "number" ? { index: e } : e;
  return t.align || (t.align = "start"), (!t.behavior || !Qi) && (t.behavior = "auto"), t.offset || (t.offset = 0), t;
}
const _n = oe(
  ([
    { sizes: e, totalCount: t, listRefresh: n, gap: r },
    {
      scrollingInProgress: s,
      viewportHeight: o,
      scrollTo: i,
      smoothScrollTargetReached: a,
      headerHeight: l,
      footerHeight: u,
      fixedHeaderHeight: c,
      fixedFooterHeight: p
    },
    { log: _ }
  ]) => {
    const D = ee(), M = k(0);
    let d = null, x = null, h = null;
    function m() {
      d && (d(), d = null), h && (h(), h = null), x && (clearTimeout(x), x = null), $(s, !1);
    }
    return H(
      y(
        D,
        q(e, o, t, M, l, u, _),
        q(r, c, p),
        R(
          ([
            [T, Y, g, f, b, E, P, W],
            U,
            K,
            ie
          ]) => {
            const F = eo(T), { align: G, behavior: se, offset: _e } = F, Ye = f - 1, Ie = Qs(F, Y, Ye);
            let Me = dn(Ie, Y.offsetTree, U) + E;
            G === "end" ? (Me += K + Xe(Y.sizeTree, Ie)[1] - g + ie, Ie === Ye && (Me += P)) : G === "center" ? Me += (K + Xe(Y.sizeTree, Ie)[1] - g + ie) / 2 : Me -= b, _e && (Me += _e);
            const Le = (He) => {
              m(), He ? (W("retrying to scroll to", { location: T }, ze.DEBUG), $(D, T)) : W("list did not change, scroll successful", {}, ze.DEBUG);
            };
            if (m(), se === "smooth") {
              let He = !1;
              h = ae(n, (ct) => {
                He = He || ct;
              }), d = _t(a, () => {
                Le(He);
              });
            } else
              d = _t(y(n, Xi(150)), Le);
            return x = setTimeout(() => {
              m();
            }, 1200), $(s, !0), W("scrolling from index to", { index: Ie, top: Me, behavior: se }, ze.DEBUG), { top: Me, behavior: se };
          }
        )
      ),
      i
    ), {
      scrollToIndex: D,
      topListHeight: M
    };
  },
  me(at, Re, Rt),
  { singleton: !0 }
);
function Xi(e) {
  return (t) => {
    const n = setTimeout(() => {
      t(!1);
    }, e);
    return (r) => {
      r && (t(!0), clearTimeout(n));
    };
  };
}
const fn = "up", sn = "down", ea = "none", ta = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
}, na = 0, yn = oe(([{ scrollContainerState: e, scrollTop: t, viewportHeight: n, headerHeight: r, footerHeight: s, scrollBy: o }]) => {
  const i = k(!1), a = k(!0), l = ee(), u = ee(), c = k(4), p = k(na), _ = Ce(
    y(
      ys(y(A(t), Kt(1), ht(!0)), y(A(t), Kt(1), ht(!1), _s(100))),
      he()
    ),
    !1
  ), D = Ce(
    y(ys(y(o, ht(!0)), y(o, ht(!1), _s(200))), he()),
    !1
  );
  H(
    y(
      ke(A(t), A(p)),
      R(([m, T]) => m <= T),
      he()
    ),
    a
  ), H(y(a, It(50)), u);
  const M = Ge(
    y(
      ke(e, A(n), A(r), A(s), A(c)),
      ot((m, [{ scrollTop: T, scrollHeight: Y }, g, f, b, E]) => {
        const P = T + g - Y > -E, W = {
          viewportHeight: g,
          scrollTop: T,
          scrollHeight: Y
        };
        if (P) {
          let K, ie;
          return T > m.state.scrollTop ? (K = "SCROLLED_DOWN", ie = m.state.scrollTop - T) : (K = "SIZE_DECREASED", ie = m.state.scrollTop - T || m.scrollTopDelta), {
            atBottom: !0,
            state: W,
            atBottomBecause: K,
            scrollTopDelta: ie
          };
        }
        let U;
        return W.scrollHeight > m.state.scrollHeight ? U = "SIZE_INCREASED" : g < m.state.viewportHeight ? U = "VIEWPORT_HEIGHT_DECREASING" : T < m.state.scrollTop ? U = "SCROLLING_UPWARDS" : U = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: U,
          state: W
        };
      }, ta),
      he((m, T) => m && m.atBottom === T.atBottom)
    )
  ), d = Ce(
    y(
      e,
      ot(
        (m, { scrollTop: T, scrollHeight: Y, viewportHeight: g }) => {
          if (zs(m.scrollHeight, Y))
            return {
              scrollTop: T,
              scrollHeight: Y,
              jump: 0,
              changed: !1
            };
          {
            const f = Y - (T + g) < 1;
            return m.scrollTop !== T && f ? {
              scrollHeight: Y,
              scrollTop: T,
              jump: m.scrollTop - T,
              changed: !0
            } : {
              scrollHeight: Y,
              scrollTop: T,
              jump: 0,
              changed: !0
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: !1 }
      ),
      V((m) => m.changed),
      R((m) => m.jump)
    ),
    0
  );
  H(
    y(
      M,
      R((m) => m.atBottom)
    ),
    i
  ), H(y(i, It(50)), l);
  const x = k(sn);
  H(
    y(
      e,
      R(({ scrollTop: m }) => m),
      he(),
      ot(
        (m, T) => Ue(D) ? { direction: m.direction, prevScrollTop: T } : { direction: T < m.prevScrollTop ? fn : sn, prevScrollTop: T },
        { direction: sn, prevScrollTop: 0 }
      ),
      R((m) => m.direction)
    ),
    x
  ), H(y(e, It(50), ht(ea)), x);
  const h = k(0);
  return H(
    y(
      _,
      V((m) => !m),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      ht(0)
    ),
    h
  ), H(
    y(
      t,
      It(100),
      q(_),
      V(([m, T]) => !!T),
      ot(([m, T], [Y]) => [T, Y], [0, 0]),
      R(([m, T]) => T - m)
    ),
    h
  ), {
    isScrolling: _,
    isAtTop: a,
    isAtBottom: i,
    atBottomState: M,
    atTopStateChange: u,
    atBottomStateChange: l,
    scrollDirection: x,
    atBottomThreshold: c,
    atTopThreshold: p,
    scrollVelocity: h,
    lastJumpDueToItemResize: d
  };
}, me(Re)), Yt = oe(
  ([{ log: e }]) => {
    const t = k(!1), n = Ge(
      y(
        t,
        V((r) => r),
        he()
      )
    );
    return ae(t, (r) => {
      r && Ue(e)("props updated", {}, ze.DEBUG);
    }), { propsReady: t, didMount: n };
  },
  me(Rt),
  { singleton: !0 }
);
function Hr(e, t) {
  e == 0 ? t() : requestAnimationFrame(() => Hr(e - 1, t));
}
function Wr(e, t) {
  const n = t - 1;
  return typeof e == "number" ? e : e.index === "LAST" ? n : e.index;
}
const Sn = oe(
  ([{ sizes: e, listRefresh: t, defaultItemSize: n }, { scrollTop: r }, { scrollToIndex: s }, { didMount: o }]) => {
    const i = k(!0), a = k(0), l = k(!1);
    return H(
      y(
        o,
        q(a),
        V(([u, c]) => !!c),
        ht(!1)
      ),
      i
    ), ae(
      y(
        ke(t, o),
        q(i, e, n, l),
        V(([[, u], c, { sizeTree: p }, _, D]) => u && (!ue(p) || Yr(_)) && !c && !D),
        q(a)
      ),
      ([, u]) => {
        $(l, !0), Hr(3, () => {
          _t(r, () => $(i, !0)), $(s, u);
        });
      }
    ), {
      scrolledToInitialItem: i,
      initialTopMostItemIndex: a
    };
  },
  me(at, Re, _n, Yt),
  { singleton: !0 }
);
function vs(e) {
  return e ? e === "smooth" ? "smooth" : "auto" : !1;
}
const ra = (e, t) => typeof e == "function" ? vs(e(t)) : t && vs(e), sa = oe(
  ([
    { totalCount: e, listRefresh: t },
    { isAtBottom: n, atBottomState: r },
    { scrollToIndex: s },
    { scrolledToInitialItem: o },
    { propsReady: i, didMount: a },
    { log: l },
    { scrollingInProgress: u }
  ]) => {
    const c = k(!1), p = ee();
    let _ = null;
    function D(d) {
      $(s, {
        index: "LAST",
        align: "end",
        behavior: d
      });
    }
    ae(
      y(
        ke(y(A(e), Kt(1)), a),
        q(A(c), n, o, u),
        R(([[d, x], h, m, T, Y]) => {
          let g = x && T, f = "auto";
          return g && (f = ra(h, m || Y), g = g && !!f), { totalCount: d, shouldFollow: g, followOutputBehavior: f };
        }),
        V(({ shouldFollow: d }) => d)
      ),
      ({ totalCount: d, followOutputBehavior: x }) => {
        _ && (_(), _ = null), _ = _t(t, () => {
          Ue(l)("following output to ", { totalCount: d }, ze.DEBUG), D(x), _ = null;
        });
      }
    );
    function M(d) {
      const x = _t(r, (h) => {
        d && !h.atBottom && h.notAtBottomBecause === "SIZE_INCREASED" && !_ && (Ue(l)("scrolling to bottom due to increased size", {}, ze.DEBUG), D("auto"));
      });
      setTimeout(x, 100);
    }
    return ae(
      y(
        ke(A(c), e, i),
        V(([d, , x]) => d && x),
        ot(
          ({ value: d }, [, x]) => ({ refreshed: d === x, value: x }),
          { refreshed: !1, value: 0 }
        ),
        V(({ refreshed: d }) => d),
        q(c, e)
      ),
      ([, d]) => {
        M(d !== !1);
      }
    ), ae(p, () => {
      M(Ue(c) !== !1);
    }), ae(ke(A(c), r), ([d, x]) => {
      d && !x.atBottom && x.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && D("auto");
    }), { followOutput: c, autoscrollToBottom: p };
  },
  me(at, yn, _n, Sn, Yt, Rt, Re)
);
function oa(e) {
  return e.reduce(
    (t, n) => (t.groupIndices.push(t.totalCount), t.totalCount += n + 1, t),
    {
      totalCount: 0,
      groupIndices: []
    }
  );
}
const to = oe(([{ totalCount: e, groupIndices: t, sizes: n }, { scrollTop: r, headerHeight: s }]) => {
  const o = ee(), i = ee(), a = Ge(y(o, R(oa)));
  return H(
    y(
      a,
      R((l) => l.totalCount)
    ),
    e
  ), H(
    y(
      a,
      R((l) => l.groupIndices)
    ),
    t
  ), H(
    y(
      ke(r, n, s),
      V(([l, u]) => qn(u)),
      R(([l, u, c]) => Xe(u.groupOffsetTree, Math.max(l - c, 0), "v")[0]),
      he(),
      R((l) => [l])
    ),
    i
  ), { groupCounts: o, topItemsIndexes: i };
}, me(at, Re));
function hn(e, t) {
  return !!(e && e[0] === t[0] && e[1] === t[1]);
}
function no(e, t) {
  return !!(e && e.startIndex === t.startIndex && e.endIndex === t.endIndex);
}
const Hn = "top", Wn = "bottom", xs = "none";
function Ts(e, t, n) {
  return typeof e == "number" ? n === fn && t === Hn || n === sn && t === Wn ? e : 0 : n === fn ? t === Hn ? e.main : e.reverse : t === Wn ? e.main : e.reverse;
}
function ks(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Fr = oe(
  ([{ scrollTop: e, viewportHeight: t, deviation: n, headerHeight: r, fixedHeaderHeight: s }]) => {
    const o = ee(), i = k(0), a = k(0), l = k(0), u = Ce(
      y(
        ke(
          A(e),
          A(t),
          A(r),
          A(o, hn),
          A(l),
          A(i),
          A(s),
          A(n),
          A(a)
        ),
        R(
          ([
            c,
            p,
            _,
            [D, M],
            d,
            x,
            h,
            m,
            T
          ]) => {
            const Y = c - m, g = x + h, f = Math.max(_ - Y, 0);
            let b = xs;
            const E = ks(T, Hn), P = ks(T, Wn);
            return D -= m, D += _ + h, M += _ + h, M -= m, D > c + g - E && (b = fn), M < c - f + p + P && (b = sn), b !== xs ? [
              Math.max(Y - _ - Ts(d, Hn, b) - E, 0),
              Y - f - h + p + Ts(d, Wn, b) + P
            ] : null;
          }
        ),
        V((c) => c != null),
        he(hn)
      ),
      [0, 0]
    );
    return {
      // input
      listBoundary: o,
      overscan: l,
      topListHeight: i,
      increaseViewportBy: a,
      // output
      visibleRange: u
    };
  },
  me(Re),
  { singleton: !0 }
);
function ia(e, t, n) {
  if (qn(t)) {
    const r = Xs(e, t);
    return [
      { index: Xe(t.groupOffsetTree, r)[0], size: 0, offset: 0 },
      { index: r, size: 0, offset: 0, data: n && n[0] }
    ];
  }
  return [{ index: e, size: 0, offset: 0, data: n && n[0] }];
}
const hr = {
  items: [],
  topItems: [],
  offsetTop: 0,
  offsetBottom: 0,
  top: 0,
  bottom: 0,
  topListHeight: 0,
  totalCount: 0,
  firstItemIndex: 0
};
function Is(e, t, n) {
  if (e.length === 0)
    return [];
  if (!qn(t))
    return e.map((u) => ({ ...u, index: u.index + n, originalIndex: u.index }));
  const r = e[0].index, s = e[e.length - 1].index, o = [], i = Zn(t.groupOffsetTree, r, s);
  let a, l = 0;
  for (const u of e) {
    (!a || a.end < u.index) && (a = i.shift(), l = t.groupIndices.indexOf(a.start));
    let c;
    u.index === a.start ? c = {
      type: "group",
      index: l
    } : c = {
      index: u.index - (l + 1) + n,
      groupIndex: l
    }, o.push({
      ...c,
      size: u.size,
      offset: u.offset,
      originalIndex: u.index,
      data: u.data
    });
  }
  return o;
}
function Yn(e, t, n, r, s, o) {
  const { lastSize: i, lastOffset: a, lastIndex: l } = s;
  let u = 0, c = 0;
  if (e.length > 0) {
    u = e[0].offset;
    const d = e[e.length - 1];
    c = d.offset + d.size;
  }
  const p = n - l, _ = a + p * i + (p - 1) * r, D = u, M = _ - c;
  return {
    items: Is(e, s, o),
    topItems: Is(t, s, o),
    topListHeight: t.reduce((d, x) => x.size + d, 0),
    offsetTop: u,
    offsetBottom: M,
    top: D,
    bottom: c,
    totalCount: n,
    firstItemIndex: o
  };
}
function ro(e, t, n, r, s, o) {
  let i = 0;
  if (n.groupIndices.length > 0)
    for (const c of n.groupIndices) {
      if (c - i >= e)
        break;
      i++;
    }
  const a = e + i, l = Wr(t, a), u = Array.from({ length: a }).map((c, p) => ({
    index: p + l,
    size: 0,
    offset: 0,
    data: o[p + l]
  }));
  return Yn(u, [], a, s, n, r);
}
const At = oe(
  ([
    { sizes: e, totalCount: t, data: n, firstItemIndex: r, gap: s },
    o,
    { visibleRange: i, listBoundary: a, topListHeight: l },
    { scrolledToInitialItem: u, initialTopMostItemIndex: c },
    { topListHeight: p },
    _,
    { didMount: D },
    { recalcInProgress: M }
  ]) => {
    const d = k([]), x = k(0), h = ee();
    H(o.topItemsIndexes, d);
    const m = Ce(
      y(
        ke(
          D,
          M,
          A(i, hn),
          A(t),
          A(e),
          A(c),
          u,
          A(d),
          A(r),
          A(s),
          n
        ),
        V(([f, b, , E, , , , , , , P]) => {
          const W = P && P.length !== E;
          return f && !b && !W;
        }),
        R(
          ([
            ,
            ,
            [f, b],
            E,
            P,
            W,
            U,
            K,
            ie,
            F,
            G
          ]) => {
            const se = P, { sizeTree: _e, offsetTree: Ye } = se, Ie = Ue(x);
            if (E === 0)
              return { ...hr, totalCount: E };
            if (f === 0 && b === 0)
              return Ie === 0 ? { ...hr, totalCount: E } : ro(Ie, W, P, ie, F, G || []);
            if (ue(_e))
              return Ie > 0 ? null : Yn(
                ia(Wr(W, E), se, G),
                [],
                E,
                F,
                se,
                ie
              );
            const Me = [];
            if (K.length > 0) {
              const xt = K[0], w = K[K.length - 1];
              let Z = 0;
              for (const re of Zn(_e, xt, w)) {
                const pe = re.value, Te = Math.max(re.start, xt), We = Math.min(re.end, w);
                for (let we = Te; we <= We; we++)
                  Me.push({ index: we, size: pe, offset: Z, data: G && G[we] }), Z += pe;
              }
            }
            if (!U)
              return Yn([], Me, E, F, se, ie);
            const Le = K.length > 0 ? K[K.length - 1] + 1 : 0, He = ji(Ye, f, b, Le);
            if (He.length === 0)
              return null;
            const ct = E - 1, vt = jn([], (xt) => {
              for (const w of He) {
                const Z = w.value;
                let re = Z.offset, pe = w.start;
                const Te = Z.size;
                if (Z.offset < f) {
                  pe += Math.floor((f - Z.offset + F) / (Te + F));
                  const we = pe - w.start;
                  re += we * Te + we * F;
                }
                pe < Le && (re += (Le - pe) * Te, pe = Le);
                const We = Math.min(w.end, ct);
                for (let we = pe; we <= We && !(re >= b); we++)
                  xt.push({ index: we, size: Te, offset: re, data: G && G[we] }), re += Te + F;
              }
            });
            return Yn(vt, Me, E, F, se, ie);
          }
        ),
        //@ts-expect-error filter needs to be fixed
        V((f) => f !== null),
        he()
      ),
      hr
    );
    H(
      y(
        n,
        V(Yr),
        R((f) => f == null ? void 0 : f.length)
      ),
      t
    ), H(
      y(
        m,
        R((f) => f.topListHeight)
      ),
      p
    ), H(p, l), H(
      y(
        m,
        R((f) => [f.top, f.bottom])
      ),
      a
    ), H(
      y(
        m,
        R((f) => f.items)
      ),
      h
    );
    const T = Ge(
      y(
        m,
        V(({ items: f }) => f.length > 0),
        q(t, n),
        V(([{ items: f }, b]) => f[f.length - 1].originalIndex === b - 1),
        R(([, f, b]) => [f - 1, b]),
        he(hn),
        R(([f]) => f)
      )
    ), Y = Ge(
      y(
        m,
        It(200),
        V(({ items: f, topItems: b }) => f.length > 0 && f[0].originalIndex === b.length),
        R(({ items: f }) => f[0].index),
        he()
      )
    ), g = Ge(
      y(
        m,
        V(({ items: f }) => f.length > 0),
        R(({ items: f }) => {
          let b = 0, E = f.length - 1;
          for (; f[b].type === "group" && b < E; )
            b++;
          for (; f[E].type === "group" && E > b; )
            E--;
          return {
            startIndex: f[b].index,
            endIndex: f[E].index
          };
        }),
        he(no)
      )
    );
    return { listState: m, topItemsIndexes: d, endReached: T, startReached: Y, rangeChanged: g, itemsRendered: h, initialItemCount: x, ..._ };
  },
  me(
    at,
    to,
    Fr,
    Sn,
    _n,
    yn,
    Yt,
    Pr
  ),
  { singleton: !0 }
), aa = oe(
  ([{ sizes: e, firstItemIndex: t, data: n, gap: r }, { initialTopMostItemIndex: s }, { initialItemCount: o, listState: i }, { didMount: a }]) => (H(
    y(
      a,
      q(o),
      V(([, l]) => l !== 0),
      q(s, e, t, r, n),
      R(([[, l], u, c, p, _, D = []]) => ro(l, u, c, p, _, D))
    ),
    i
  ), {}),
  me(at, Sn, At, Yt),
  { singleton: !0 }
), so = oe(
  ([{ scrollVelocity: e }]) => {
    const t = k(!1), n = ee(), r = k(!1);
    return H(
      y(
        e,
        q(r, t, n),
        V(([s, o]) => !!o),
        R(([s, o, i, a]) => {
          const { exit: l, enter: u } = o;
          if (i) {
            if (l(s, a))
              return !1;
          } else if (u(s, a))
            return !0;
          return i;
        }),
        he()
      ),
      t
    ), ae(
      y(ke(t, e, n), q(r)),
      ([[s, o, i], a]) => s && a && a.change && a.change(o, i)
    ), { isSeeking: t, scrollSeekConfiguration: r, scrollVelocity: e, scrollSeekRangeChanged: n };
  },
  me(yn),
  { singleton: !0 }
), la = oe(([{ topItemsIndexes: e }]) => {
  const t = k(0);
  return H(
    y(
      t,
      V((n) => n > 0),
      R((n) => Array.from({ length: n }).map((r, s) => s))
    ),
    e
  ), { topItemCount: t };
}, me(At)), oo = oe(
  ([{ footerHeight: e, headerHeight: t, fixedHeaderHeight: n, fixedFooterHeight: r }, { listState: s }]) => {
    const o = ee(), i = Ce(
      y(
        ke(e, r, t, n, s),
        R(([a, l, u, c, p]) => a + l + u + c + p.offsetBottom + p.bottom)
      ),
      0
    );
    return H(A(i), o), { totalListHeight: i, totalListHeightChanged: o };
  },
  me(Re, At),
  { singleton: !0 }
);
function io(e) {
  let t = !1, n;
  return () => (t || (t = !0, n = e()), n);
}
const ua = io(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)), ca = oe(
  ([
    { scrollBy: e, scrollTop: t, deviation: n, scrollingInProgress: r },
    { isScrolling: s, isAtBottom: o, scrollDirection: i, lastJumpDueToItemResize: a },
    { listState: l },
    { beforeUnshiftWith: u, shiftWithOffset: c, sizes: p, gap: _ },
    { log: D },
    { recalcInProgress: M }
  ]) => {
    const d = Ge(
      y(
        l,
        q(a),
        ot(
          ([, h, m, T], [{ items: Y, totalCount: g, bottom: f, offsetBottom: b }, E]) => {
            const P = f + b;
            let W = 0;
            return m === g && h.length > 0 && Y.length > 0 && (Y[0].originalIndex === 0 && h[0].originalIndex === 0 || (W = P - T, W !== 0 && (W += E))), [W, Y, g, P];
          },
          [0, [], 0, 0]
        ),
        V(([h]) => h !== 0),
        q(t, i, r, o, D, M),
        V(([, h, m, T, , , Y]) => !Y && !T && h !== 0 && m === fn),
        R(([[h], , , , , m]) => (m("Upward scrolling compensation", { amount: h }, ze.DEBUG), h))
      )
    );
    function x(h) {
      h > 0 ? ($(e, { top: -h, behavior: "auto" }), $(n, 0)) : ($(n, 0), $(e, { top: -h, behavior: "auto" }));
    }
    return ae(y(d, q(n, s)), ([h, m, T]) => {
      T && ua() ? $(n, m - h) : x(-h);
    }), ae(
      y(
        ke(Ce(s, !1), n, M),
        V(([h, m, T]) => !h && !T && m !== 0),
        R(([h, m]) => m),
        It(1)
      ),
      x
    ), H(
      y(
        c,
        R((h) => ({ top: -h }))
      ),
      e
    ), ae(
      y(
        u,
        q(p, _),
        R(([h, { lastSize: m, groupIndices: T, sizeTree: Y }, g]) => {
          function f(b) {
            return b * (m + g);
          }
          if (T.length === 0)
            return f(h);
          {
            let b = 0;
            const E = cn(Y, 0);
            let P = 0, W = 0;
            for (; P < h; ) {
              P++, b += E;
              let U = T.length === W + 1 ? 1 / 0 : T[W + 1] - T[W] - 1;
              P + U > h && (b -= E, U = h - P + 1), P += U, b += f(U), W++;
            }
            return b;
          }
        })
      ),
      (h) => {
        $(n, h), requestAnimationFrame(() => {
          $(e, { top: h }), requestAnimationFrame(() => {
            $(n, 0), $(M, !1);
          });
        });
      }
    ), { deviation: n };
  },
  me(Re, yn, At, at, Rt, Pr)
), da = oe(
  ([{ didMount: e }, { scrollTo: t }, { listState: n }]) => {
    const r = k(0);
    return ae(
      y(
        e,
        q(r),
        V(([, s]) => s !== 0),
        R(([, s]) => ({ top: s }))
      ),
      (s) => {
        _t(
          y(
            n,
            Kt(1),
            V((o) => o.items.length > 1)
          ),
          () => {
            requestAnimationFrame(() => {
              $(t, s);
            });
          }
        );
      }
    ), {
      initialScrollTop: r
    };
  },
  me(Yt, Re, At),
  { singleton: !0 }
), fa = oe(
  ([{ viewportHeight: e }, { totalListHeight: t }]) => {
    const n = k(!1), r = Ce(
      y(
        ke(n, e, t),
        V(([s]) => s),
        R(([, s, o]) => Math.max(0, s - o)),
        It(0),
        he()
      ),
      0
    );
    return { alignToBottom: n, paddingTopAddition: r };
  },
  me(Re, oo),
  { singleton: !0 }
), Ar = oe(([{ scrollTo: e, scrollContainerState: t }]) => {
  const n = ee(), r = ee(), s = ee(), o = k(!1), i = k(void 0);
  return H(
    y(
      ke(n, r),
      R(([{ viewportHeight: a, scrollTop: l, scrollHeight: u }, { offsetTop: c }]) => ({
        scrollTop: Math.max(0, l - c),
        scrollHeight: u,
        viewportHeight: a
      }))
    ),
    t
  ), H(
    y(
      e,
      q(r),
      R(([a, { offsetTop: l }]) => ({
        ...a,
        top: a.top + l
      }))
    ),
    s
  ), {
    // config
    useWindowScroll: o,
    customScrollParent: i,
    // input
    windowScrollContainerState: n,
    windowViewportRect: r,
    // signals
    windowScrollTo: s
  };
}, me(Re)), ha = ({
  itemTop: e,
  itemBottom: t,
  viewportTop: n,
  viewportBottom: r,
  locationParams: { behavior: s, align: o, ...i }
}) => e < n ? { ...i, behavior: s, align: o ?? "start" } : t > r ? { ...i, behavior: s, align: o ?? "end" } : null, ma = oe(
  ([
    { sizes: e, totalCount: t, gap: n },
    { scrollTop: r, viewportHeight: s, headerHeight: o, fixedHeaderHeight: i, fixedFooterHeight: a, scrollingInProgress: l },
    { scrollToIndex: u }
  ]) => {
    const c = ee();
    return H(
      y(
        c,
        q(e, s, t, o, i, a, r),
        q(n),
        R(([[p, _, D, M, d, x, h, m], T]) => {
          const { done: Y, behavior: g, align: f, calculateViewLocation: b = ha, ...E } = p, P = Qs(p, _, M - 1), W = dn(P, _.offsetTree, T) + d + x, U = W + Xe(_.sizeTree, P)[1], K = m + x, ie = m + D - h, F = b({
            itemTop: W,
            itemBottom: U,
            viewportTop: K,
            viewportBottom: ie,
            locationParams: { behavior: g, align: f, ...E }
          });
          return F ? Y && _t(
            y(
              l,
              V((G) => G === !1),
              // skips the initial publish of false, and the cleanup call.
              // but if scrollingInProgress is true, we skip the initial publish.
              Kt(Ue(l) ? 1 : 2)
            ),
            Y
          ) : Y && Y(), F;
        }),
        V((p) => p !== null)
      ),
      u
    ), {
      scrollIntoView: c
    };
  },
  me(at, Re, _n, At, Rt),
  { singleton: !0 }
), pa = oe(
  ([
    { sizes: e, sizeRanges: t },
    { scrollTop: n },
    { initialTopMostItemIndex: r },
    { didMount: s },
    { useWindowScroll: o, windowScrollContainerState: i, windowViewportRect: a }
  ]) => {
    const l = ee(), u = k(void 0), c = k(null), p = k(null);
    return H(i, c), H(a, p), ae(
      y(l, q(e, n, o, c, p)),
      ([_, D, M, d, x, h]) => {
        const m = Ki(D.sizeTree);
        d && x !== null && h !== null && (M = x.scrollTop - h.offsetTop), _({ ranges: m, scrollTop: M });
      }
    ), H(y(u, V(Yr), R(ga)), r), H(
      y(
        s,
        q(u),
        V(([, _]) => _ !== void 0),
        he(),
        R(([, _]) => _.ranges)
      ),
      t
    ), {
      getState: l,
      restoreStateFrom: u
    };
  },
  me(at, Re, Sn, Yt, Ar)
);
function ga(e) {
  return { offset: e.scrollTop, index: 0, align: "start" };
}
const _a = oe(
  ([
    e,
    t,
    n,
    r,
    s,
    o,
    i,
    a,
    l,
    u
  ]) => ({
    ...e,
    ...t,
    ...n,
    ...r,
    ...s,
    ...o,
    ...i,
    ...a,
    ...l,
    ...u
  }),
  me(
    Fr,
    aa,
    Yt,
    so,
    oo,
    da,
    fa,
    Ar,
    ma,
    Rt
  )
), ya = oe(
  ([
    {
      totalCount: e,
      sizeRanges: t,
      fixedItemSize: n,
      defaultItemSize: r,
      trackItemSizes: s,
      itemSize: o,
      data: i,
      firstItemIndex: a,
      groupIndices: l,
      statefulTotalCount: u,
      gap: c,
      sizes: p
    },
    { initialTopMostItemIndex: _, scrolledToInitialItem: D },
    M,
    d,
    x,
    { listState: h, topItemsIndexes: m, ...T },
    { scrollToIndex: Y },
    g,
    { topItemCount: f },
    { groupCounts: b },
    E
  ]) => (H(T.rangeChanged, E.scrollSeekRangeChanged), H(
    y(
      E.windowViewportRect,
      R((P) => P.visibleHeight)
    ),
    M.viewportHeight
  ), {
    // input
    totalCount: e,
    data: i,
    firstItemIndex: a,
    sizeRanges: t,
    initialTopMostItemIndex: _,
    scrolledToInitialItem: D,
    topItemsIndexes: m,
    topItemCount: f,
    groupCounts: b,
    fixedItemHeight: n,
    defaultItemHeight: r,
    gap: c,
    ...x,
    // output
    statefulTotalCount: u,
    listState: h,
    scrollToIndex: Y,
    trackItemSizes: s,
    itemSize: o,
    groupIndices: l,
    // exported from stateFlagsSystem
    ...T,
    // the bag of IO from featureGroup1System
    ...E,
    ...M,
    sizes: p,
    ...d
  }),
  me(
    at,
    Sn,
    Re,
    pa,
    sa,
    At,
    _n,
    ca,
    la,
    to,
    _a
  )
), mr = "-webkit-sticky", Ms = "sticky", ao = io(() => {
  if (typeof document > "u")
    return Ms;
  const e = document.createElement("div");
  return e.style.position = mr, e.style.position === mr ? mr : Ms;
});
function lo(e, t) {
  const n = v.useRef(null), r = v.useCallback(
    (a) => {
      if (a === null || !a.offsetParent)
        return;
      const l = a.getBoundingClientRect(), u = l.width;
      let c, p;
      if (t) {
        const _ = t.getBoundingClientRect(), D = l.top - _.top;
        c = _.height - Math.max(0, D), p = D + t.scrollTop;
      } else
        c = window.innerHeight - Math.max(0, l.top), p = l.top + window.pageYOffset;
      n.current = {
        offsetTop: p,
        visibleHeight: c,
        visibleWidth: u
      }, e(n.current);
    },
    [e, t]
  ), { callbackRef: s, ref: o } = Nr(r), i = v.useCallback(() => {
    r(o.current);
  }, [r, o]);
  return v.useEffect(() => {
    if (t) {
      t.addEventListener("scroll", i);
      const a = new ResizeObserver(i);
      return a.observe(t), () => {
        t.removeEventListener("scroll", i), a.unobserve(t);
      };
    } else
      return window.addEventListener("scroll", i), window.addEventListener("resize", i), () => {
        window.removeEventListener("scroll", i), window.removeEventListener("resize", i);
      };
  }, [i, t]), s;
}
const uo = v.createContext(void 0), co = v.createContext(void 0);
function fo(e) {
  return e;
}
const Sa = /* @__PURE__ */ oe(() => {
  const e = k((l) => `Item ${l}`), t = k(null), n = k((l) => `Group ${l}`), r = k({}), s = k(fo), o = k("div"), i = k(Qt), a = (l, u = null) => Ce(
    y(
      r,
      R((c) => c[l]),
      he()
    ),
    u
  );
  return {
    context: t,
    itemContent: e,
    groupContent: n,
    components: r,
    computeItemKey: s,
    headerFooterTag: o,
    scrollerRef: i,
    FooterComponent: a("Footer"),
    HeaderComponent: a("Header"),
    TopItemListComponent: a("TopItemList"),
    ListComponent: a("List", "div"),
    ItemComponent: a("Item", "div"),
    GroupComponent: a("Group", "div"),
    ScrollerComponent: a("Scroller", "div"),
    EmptyPlaceholder: a("EmptyPlaceholder"),
    ScrollSeekPlaceholder: a("ScrollSeekPlaceholder")
  };
}), wa = /* @__PURE__ */ oe(([e, t]) => ({ ...e, ...t }), me(ya, Sa)), va = ({ height: e }) => /* @__PURE__ */ v.createElement("div", { style: { height: e } }), xa = { position: ao(), zIndex: 1, overflowAnchor: "none" }, Ta = { overflowAnchor: "none" }, Ds = /* @__PURE__ */ v.memo(function({ showTopList: t = !1 }) {
  const n = Q("listState"), r = je("sizeRanges"), s = Q("useWindowScroll"), o = Q("customScrollParent"), i = je("windowScrollContainerState"), a = je("scrollContainerState"), l = o || s ? i : a, u = Q("itemContent"), c = Q("context"), p = Q("groupContent"), _ = Q("trackItemSizes"), D = Q("itemSize"), M = Q("log"), d = je("gap"), { callbackRef: x } = Hi(
    r,
    D,
    _,
    t ? Qt : l,
    M,
    d,
    o
  ), [h, m] = v.useState(0);
  Vr("deviation", (F) => {
    h !== F && m(F);
  });
  const T = Q("EmptyPlaceholder"), Y = Q("ScrollSeekPlaceholder") || va, g = Q("ListComponent"), f = Q("ItemComponent"), b = Q("GroupComponent"), E = Q("computeItemKey"), P = Q("isSeeking"), W = Q("groupIndices").length > 0, U = Q("paddingTopAddition"), K = Q("scrolledToInitialItem"), ie = t ? {} : {
    boxSizing: "border-box",
    paddingTop: n.offsetTop + U,
    paddingBottom: n.offsetBottom,
    marginTop: h,
    ...K ? {} : { visibility: "hidden" }
  };
  return !t && n.totalCount === 0 && T ? v.createElement(T, Pe(T, c)) : v.createElement(
    g,
    {
      ...Pe(g, c),
      ref: x,
      style: ie,
      "data-test-id": t ? "virtuoso-top-item-list" : "virtuoso-item-list"
    },
    (t ? n.topItems : n.items).map((F) => {
      const G = F.originalIndex, se = E(G + n.firstItemIndex, F.data, c);
      return P ? v.createElement(Y, {
        ...Pe(Y, c),
        key: se,
        index: F.index,
        height: F.size,
        type: F.type || "item",
        ...F.type === "group" ? {} : { groupIndex: F.groupIndex }
      }) : F.type === "group" ? v.createElement(
        b,
        {
          ...Pe(b, c),
          key: se,
          "data-index": G,
          "data-known-size": F.size,
          "data-item-index": F.index,
          style: xa
        },
        p(F.index, c)
      ) : v.createElement(
        f,
        {
          ...Pe(f, c),
          ...Ma(f, F.data),
          key: se,
          "data-index": G,
          "data-known-size": F.size,
          "data-item-index": F.index,
          "data-item-group-index": F.groupIndex,
          style: Ta
        },
        W ? u(F.index, F.groupIndex, F.data, c) : u(F.index, F.data, c)
      );
    })
  );
}), ka = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, Kn = {
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0
}, Ia = {
  width: "100%",
  position: ao(),
  top: 0,
  zIndex: 1
};
function Pe(e, t) {
  if (typeof e != "string")
    return { context: t };
}
function Ma(e, t) {
  return { item: typeof e == "string" ? void 0 : t };
}
const Da = /* @__PURE__ */ v.memo(function() {
  const t = Q("HeaderComponent"), n = je("headerHeight"), r = Q("headerFooterTag"), s = Ft((i) => n(Ot(i, "height"))), o = Q("context");
  return t ? v.createElement(r, { ref: s }, v.createElement(t, Pe(t, o))) : null;
}), ba = /* @__PURE__ */ v.memo(function() {
  const t = Q("FooterComponent"), n = je("footerHeight"), r = Q("headerFooterTag"), s = Ft((i) => n(Ot(i, "height"))), o = Q("context");
  return t ? v.createElement(r, { ref: s }, v.createElement(t, Pe(t, o))) : null;
});
function ho({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return v.memo(function({ style: o, children: i, ...a }) {
    const l = e("scrollContainerState"), u = n("ScrollerComponent"), c = e("smoothScrollTargetReached"), p = n("scrollerRef"), _ = n("context"), { scrollerRef: D, scrollByCallback: M, scrollToCallback: d } = Bs(
      l,
      c,
      u,
      p
    );
    return t("scrollTo", d), t("scrollBy", M), v.createElement(
      u,
      {
        ref: D,
        style: { ...ka, ...o },
        "data-test-id": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        tabIndex: 0,
        ...a,
        ...Pe(u, _)
      },
      i
    );
  });
}
function mo({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return v.memo(function({ style: o, children: i, ...a }) {
    const l = e("windowScrollContainerState"), u = n("ScrollerComponent"), c = e("smoothScrollTargetReached"), p = n("totalListHeight"), _ = n("deviation"), D = n("customScrollParent"), M = n("context"), { scrollerRef: d, scrollByCallback: x, scrollToCallback: h } = Bs(
      l,
      c,
      u,
      Qt,
      D
    );
    return Ni(() => (d.current = D || window, () => {
      d.current = null;
    }), [d, D]), t("windowScrollTo", h), t("scrollBy", x), v.createElement(
      u,
      {
        style: { position: "relative", ...o, ...p !== 0 ? { height: p + _ } : {} },
        "data-virtuoso-scroller": !0,
        ...a,
        ...Pe(u, M)
      },
      i
    );
  });
}
const Oa = ({ children: e }) => {
  const t = v.useContext(uo), n = je("viewportHeight"), r = je("fixedItemHeight"), s = Ft(As(n, (o) => Ot(o, "height")));
  return v.useEffect(() => {
    t && (n(t.viewportHeight), r(t.itemHeight));
  }, [t, n, r]), /* @__PURE__ */ v.createElement("div", { style: Kn, ref: s, "data-viewport-type": "element" }, e);
}, Ca = ({ children: e }) => {
  const t = v.useContext(uo), n = je("windowViewportRect"), r = je("fixedItemHeight"), s = Q("customScrollParent"), o = lo(n, s);
  return v.useEffect(() => {
    t && (r(t.itemHeight), n({ offsetTop: 0, visibleHeight: t.viewportHeight, visibleWidth: 100 }));
  }, [t, n, r]), /* @__PURE__ */ v.createElement("div", { ref: o, style: Kn, "data-viewport-type": "window" }, e);
}, Ra = ({ children: e }) => {
  const t = Q("TopItemListComponent"), n = Q("headerHeight"), r = { ...Ia, marginTop: `${n}px` }, s = Q("context");
  return v.createElement(t || "div", { style: r, context: s }, e);
}, Ya = /* @__PURE__ */ v.memo(function(t) {
  const n = Q("useWindowScroll"), r = Q("topItemsIndexes").length > 0, s = Q("customScrollParent"), o = s || n ? Pa : Na, i = s || n ? Ca : Oa;
  return /* @__PURE__ */ v.createElement(o, { ...t }, r && /* @__PURE__ */ v.createElement(Ra, null, /* @__PURE__ */ v.createElement(Ds, { showTopList: !0 })), /* @__PURE__ */ v.createElement(i, null, /* @__PURE__ */ v.createElement(Da, null), /* @__PURE__ */ v.createElement(Ds, null), /* @__PURE__ */ v.createElement(ba, null)));
}), {
  Component: Ea,
  usePublisher: je,
  useEmitterValue: Q,
  useEmitter: Vr
} = /* @__PURE__ */ Gs(
  wa,
  {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      itemContent: "itemContent",
      groupContent: "groupContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      groupCounts: "groupCounts",
      topItemCount: "topItemCount",
      firstItemIndex: "firstItemIndex",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  Ya
), Na = /* @__PURE__ */ ho({ usePublisher: je, useEmitterValue: Q, useEmitter: Vr }), Pa = /* @__PURE__ */ mo({ usePublisher: je, useEmitterValue: Q, useEmitter: Vr }), La = Ea, bs = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, Ha = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, { round: Os, ceil: Cs, floor: Fn, min: pr, max: on } = Math;
function Wa(e) {
  return {
    ...Ha,
    items: e
  };
}
function Rs(e, t, n) {
  return Array.from({ length: t - e + 1 }).map((r, s) => {
    const o = n === null ? null : n[s + e];
    return { index: s + e, data: o };
  });
}
function Fa(e, t) {
  return e && e.column === t.column && e.row === t.row;
}
function bn(e, t) {
  return e && e.width === t.width && e.height === t.height;
}
const Aa = /* @__PURE__ */ oe(
  ([
    { overscan: e, visibleRange: t, listBoundary: n },
    { scrollTop: r, viewportHeight: s, scrollBy: o, scrollTo: i, smoothScrollTargetReached: a, scrollContainerState: l, footerHeight: u, headerHeight: c },
    p,
    _,
    { propsReady: D, didMount: M },
    { windowViewportRect: d, useWindowScroll: x, customScrollParent: h, windowScrollContainerState: m, windowScrollTo: T },
    Y
  ]) => {
    const g = k(0), f = k(0), b = k(bs), E = k({ height: 0, width: 0 }), P = k({ height: 0, width: 0 }), W = ee(), U = ee(), K = k(0), ie = k(null), F = k({ row: 0, column: 0 }), G = ee(), se = ee(), _e = k(!1), Ye = k(0), Ie = k(!0), Me = k(!1);
    ae(
      y(
        M,
        q(Ye),
        V(([w, Z]) => !!Z)
      ),
      () => {
        $(Ie, !1), $(f, 0);
      }
    ), ae(
      y(
        ke(M, Ie, P, E, Ye, Me),
        V(([w, Z, re, pe, , Te]) => w && !Z && re.height !== 0 && pe.height !== 0 && !Te)
      ),
      ([, , , , w]) => {
        $(Me, !0), Hr(1, () => {
          $(W, w);
        }), _t(y(r), () => {
          $(n, [0, 0]), $(Ie, !0);
        });
      }
    ), H(
      y(
        se,
        V((w) => w != null && w.scrollTop > 0),
        ht(0)
      ),
      f
    ), ae(
      y(
        M,
        q(se),
        V(([, w]) => w != null)
      ),
      ([, w]) => {
        w && ($(E, w.viewport), $(P, w == null ? void 0 : w.item), $(F, w.gap), w.scrollTop > 0 && ($(_e, !0), _t(y(r, Kt(1)), (Z) => {
          $(_e, !1);
        }), $(i, { top: w.scrollTop })));
      }
    ), H(
      y(
        E,
        R(({ height: w }) => w)
      ),
      s
    ), H(
      y(
        ke(
          A(E, bn),
          A(P, bn),
          A(F, (w, Z) => w && w.column === Z.column && w.row === Z.row),
          A(r)
        ),
        R(([w, Z, re, pe]) => ({
          viewport: w,
          item: Z,
          gap: re,
          scrollTop: pe
        }))
      ),
      G
    ), H(
      y(
        ke(
          A(g),
          t,
          A(F, Fa),
          A(P, bn),
          A(E, bn),
          A(ie),
          A(f),
          A(_e),
          A(Ie),
          A(Ye)
        ),
        V(([, , , , , , , w]) => !w),
        R(
          ([
            w,
            [Z, re],
            pe,
            Te,
            We,
            we,
            Tt,
            ,
            Et,
            C
          ]) => {
            const { row: N, column: z } = pe, { height: J, width: Ee } = Te, { width: rt } = We;
            if (Tt === 0 && (w === 0 || rt === 0))
              return bs;
            if (Ee === 0) {
              const ur = Wr(C, w), ui = ur === 0 ? Math.max(Tt - 1, 0) : ur;
              return Wa(Rs(ur, ui, we));
            }
            const kt = po(rt, Ee, z);
            let Ut, Nt;
            Et ? Z === 0 && re === 0 && Tt > 0 ? (Ut = 0, Nt = Tt - 1) : (Ut = kt * Fn((Z + N) / (J + N)), Nt = kt * Cs((re + N) / (J + N)) - 1, Nt = pr(w - 1, on(Nt, kt - 1)), Ut = pr(Nt, on(0, Ut))) : (Ut = 0, Nt = -1);
            const ls = Rs(Ut, Nt, we), { top: us, bottom: cs } = Ys(We, pe, Te, ls), ds = Cs(w / kt), li = ds * J + (ds - 1) * N - cs;
            return { items: ls, offsetTop: us, offsetBottom: li, top: us, bottom: cs, itemHeight: J, itemWidth: Ee };
          }
        )
      ),
      b
    ), H(
      y(
        ie,
        V((w) => w !== null),
        R((w) => w.length)
      ),
      g
    ), H(
      y(
        ke(E, P, b, F),
        V(([w, Z, { items: re }]) => re.length > 0 && Z.height !== 0 && w.height !== 0),
        R(([w, Z, { items: re }, pe]) => {
          const { top: Te, bottom: We } = Ys(w, pe, Z, re);
          return [Te, We];
        }),
        he(hn)
      ),
      n
    );
    const Le = k(!1);
    H(
      y(
        r,
        q(Le),
        R(([w, Z]) => Z || w !== 0)
      ),
      Le
    );
    const He = Ge(
      y(
        A(b),
        V(({ items: w }) => w.length > 0),
        q(g, Le),
        V(([{ items: w }, Z, re]) => re && w[w.length - 1].index === Z - 1),
        R(([, w]) => w - 1),
        he()
      )
    ), ct = Ge(
      y(
        A(b),
        V(({ items: w }) => w.length > 0 && w[0].index === 0),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        ht(0),
        he()
      )
    ), vt = Ge(
      y(
        A(b),
        q(_e),
        V(([{ items: w }, Z]) => w.length > 0 && !Z),
        R(([{ items: w }]) => ({
          startIndex: w[0].index,
          endIndex: w[w.length - 1].index
        })),
        he(no),
        It(0)
      )
    );
    H(vt, _.scrollSeekRangeChanged), H(
      y(
        W,
        q(E, P, g, F),
        R(([w, Z, re, pe, Te]) => {
          const We = eo(w), { align: we, behavior: Tt, offset: Et } = We;
          let C = We.index;
          C === "LAST" && (C = pe - 1), C = on(0, C, pr(pe - 1, C));
          let N = kr(Z, Te, re, C);
          return we === "end" ? N = Os(N - Z.height + re.height) : we === "center" && (N = Os(N - Z.height / 2 + re.height / 2)), Et && (N += Et), { top: N, behavior: Tt };
        })
      ),
      i
    );
    const xt = Ce(
      y(
        b,
        R((w) => w.offsetBottom + w.bottom)
      ),
      0
    );
    return H(
      y(
        d,
        R((w) => ({ width: w.visibleWidth, height: w.visibleHeight }))
      ),
      E
    ), {
      // input
      data: ie,
      totalCount: g,
      viewportDimensions: E,
      itemDimensions: P,
      scrollTop: r,
      scrollHeight: U,
      overscan: e,
      scrollBy: o,
      scrollTo: i,
      scrollToIndex: W,
      smoothScrollTargetReached: a,
      windowViewportRect: d,
      windowScrollTo: T,
      useWindowScroll: x,
      customScrollParent: h,
      windowScrollContainerState: m,
      deviation: K,
      scrollContainerState: l,
      footerHeight: u,
      headerHeight: c,
      initialItemCount: f,
      gap: F,
      restoreStateFrom: se,
      ..._,
      initialTopMostItemIndex: Ye,
      // output
      gridState: b,
      totalListHeight: xt,
      ...p,
      startReached: ct,
      endReached: He,
      rangeChanged: vt,
      stateChanged: G,
      propsReady: D,
      stateRestoreInProgress: _e,
      ...Y
    };
  },
  me(Fr, Re, yn, so, Yt, Ar, Rt)
);
function Ys(e, t, n, r) {
  const { height: s } = n;
  if (s === void 0 || r.length === 0)
    return { top: 0, bottom: 0 };
  const o = kr(e, t, n, r[0].index), i = kr(e, t, n, r[r.length - 1].index) + s;
  return { top: o, bottom: i };
}
function kr(e, t, n, r) {
  const s = po(e.width, n.width, t.column), o = Fn(r / s), i = o * n.height + on(0, o - 1) * t.row;
  return i > 0 ? i + t.row : i;
}
function po(e, t, n) {
  return on(1, Fn((e + n) / (Fn(t) + n)));
}
const Va = /* @__PURE__ */ oe(() => {
  const e = k((u) => `Item ${u}`), t = k({}), n = k(null), r = k("virtuoso-grid-item"), s = k("virtuoso-grid-list"), o = k(fo), i = k("div"), a = k(Qt), l = (u, c = null) => Ce(
    y(
      t,
      R((p) => p[u]),
      he()
    ),
    c
  );
  return {
    context: n,
    itemContent: e,
    components: t,
    computeItemKey: o,
    itemClassName: r,
    listClassName: s,
    headerFooterTag: i,
    scrollerRef: a,
    FooterComponent: l("Footer"),
    HeaderComponent: l("Header"),
    ListComponent: l("List", "div"),
    ItemComponent: l("Item", "div"),
    ScrollerComponent: l("Scroller", "div"),
    ScrollSeekPlaceholder: l("ScrollSeekPlaceholder", "div")
  };
}), Ua = /* @__PURE__ */ oe(([e, t]) => ({ ...e, ...t }), me(Aa, Va)), Ga = /* @__PURE__ */ v.memo(function() {
  const t = ge("gridState"), n = ge("listClassName"), r = ge("itemClassName"), s = ge("itemContent"), o = ge("computeItemKey"), i = ge("isSeeking"), a = Qe("scrollHeight"), l = ge("ItemComponent"), u = ge("ListComponent"), c = ge("ScrollSeekPlaceholder"), p = ge("context"), _ = Qe("itemDimensions"), D = Qe("gap"), M = ge("log"), d = ge("stateRestoreInProgress"), x = Ft((h) => {
    const m = h.parentElement.parentElement.scrollHeight;
    a(m);
    const T = h.firstChild;
    if (T) {
      const { width: Y, height: g } = T.getBoundingClientRect();
      _({ width: Y, height: g });
    }
    D({
      row: Es("row-gap", getComputedStyle(h).rowGap, M),
      column: Es("column-gap", getComputedStyle(h).columnGap, M)
    });
  });
  return d ? null : v.createElement(
    u,
    {
      ref: x,
      className: n,
      ...Pe(u, p),
      style: { paddingTop: t.offsetTop, paddingBottom: t.offsetBottom },
      "data-test-id": "virtuoso-item-list"
    },
    t.items.map((h) => {
      const m = o(h.index, h.data, p);
      return i ? v.createElement(c, {
        key: m,
        ...Pe(c, p),
        index: h.index,
        height: t.itemHeight,
        width: t.itemWidth
      }) : v.createElement(
        l,
        { ...Pe(l, p), className: r, "data-index": h.index, key: m },
        s(h.index, h.data, p)
      );
    })
  );
}), za = v.memo(function() {
  const t = ge("HeaderComponent"), n = Qe("headerHeight"), r = ge("headerFooterTag"), s = Ft((i) => n(Ot(i, "height"))), o = ge("context");
  return t ? v.createElement(r, { ref: s }, v.createElement(t, Pe(t, o))) : null;
}), Ba = v.memo(function() {
  const t = ge("FooterComponent"), n = Qe("footerHeight"), r = ge("headerFooterTag"), s = Ft((i) => n(Ot(i, "height"))), o = ge("context");
  return t ? v.createElement(r, { ref: s }, v.createElement(t, Pe(t, o))) : null;
}), $a = ({ children: e }) => {
  const t = v.useContext(co), n = Qe("itemDimensions"), r = Qe("viewportDimensions"), s = Ft((o) => {
    r(o.getBoundingClientRect());
  });
  return v.useEffect(() => {
    t && (r({ height: t.viewportHeight, width: t.viewportWidth }), n({ height: t.itemHeight, width: t.itemWidth }));
  }, [t, r, n]), /* @__PURE__ */ v.createElement("div", { style: Kn, ref: s }, e);
}, ja = ({ children: e }) => {
  const t = v.useContext(co), n = Qe("windowViewportRect"), r = Qe("itemDimensions"), s = ge("customScrollParent"), o = lo(n, s);
  return v.useEffect(() => {
    t && (r({ height: t.itemHeight, width: t.itemWidth }), n({ offsetTop: 0, visibleHeight: t.viewportHeight, visibleWidth: t.viewportWidth }));
  }, [t, n, r]), /* @__PURE__ */ v.createElement("div", { ref: o, style: Kn }, e);
}, Za = /* @__PURE__ */ v.memo(function({ ...t }) {
  const n = ge("useWindowScroll"), r = ge("customScrollParent"), s = r || n ? Ka : qa, o = r || n ? ja : $a;
  return /* @__PURE__ */ v.createElement(s, { ...t }, /* @__PURE__ */ v.createElement(o, null, /* @__PURE__ */ v.createElement(za, null), /* @__PURE__ */ v.createElement(Ga, null), /* @__PURE__ */ v.createElement(Ba, null)));
}), {
  Component: nh,
  usePublisher: Qe,
  useEmitterValue: ge,
  useEmitter: go
} = /* @__PURE__ */ Gs(
  Ua,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged"
    }
  },
  Za
), qa = /* @__PURE__ */ ho({ usePublisher: Qe, useEmitterValue: ge, useEmitter: go }), Ka = /* @__PURE__ */ mo({ usePublisher: Qe, useEmitterValue: ge, useEmitter: go });
function Es(e, t, n) {
  return t !== "normal" && !(t != null && t.endsWith("px")) && n(`${e} was not resolved to pixel value correctly`, t, ze.WARN), t === "normal" ? 0 : parseInt(t ?? "0", 10);
}
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var _o;
function I() {
  return _o.apply(null, arguments);
}
function Ja(e) {
  _o = e;
}
function et(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Wt(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function te(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Ur(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (te(e, t))
      return !1;
  return !0;
}
function Ne(e) {
  return e === void 0;
}
function yt(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function wn(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function yo(e, t) {
  var n = [], r, s = e.length;
  for (r = 0; r < s; ++r)
    n.push(t(e[r], r));
  return n;
}
function Mt(e, t) {
  for (var n in t)
    te(t, n) && (e[n] = t[n]);
  return te(t, "toString") && (e.toString = t.toString), te(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function lt(e, t, n, r) {
  return Uo(e, t, n, r, !0).utc();
}
function Qa() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function B(e) {
  return e._pf == null && (e._pf = Qa()), e._pf;
}
var Ir;
Array.prototype.some ? Ir = Array.prototype.some : Ir = function(e) {
  var t = Object(this), n = t.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function Gr(e) {
  if (e._isValid == null) {
    var t = B(e), n = Ir.call(t.parsedDateParts, function(s) {
      return s != null;
    }), r = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
    if (e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = r;
    else
      return r;
  }
  return e._isValid;
}
function Jn(e) {
  var t = lt(NaN);
  return e != null ? Mt(B(t), e) : B(t).userInvalidated = !0, t;
}
var Ns = I.momentProperties = [], gr = !1;
function zr(e, t) {
  var n, r, s, o = Ns.length;
  if (Ne(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ne(t._i) || (e._i = t._i), Ne(t._f) || (e._f = t._f), Ne(t._l) || (e._l = t._l), Ne(t._strict) || (e._strict = t._strict), Ne(t._tzm) || (e._tzm = t._tzm), Ne(t._isUTC) || (e._isUTC = t._isUTC), Ne(t._offset) || (e._offset = t._offset), Ne(t._pf) || (e._pf = B(t)), Ne(t._locale) || (e._locale = t._locale), o > 0)
    for (n = 0; n < o; n++)
      r = Ns[n], s = t[r], Ne(s) || (e[r] = s);
  return e;
}
function vn(e) {
  zr(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), gr === !1 && (gr = !0, I.updateOffset(this), gr = !1);
}
function tt(e) {
  return e instanceof vn || e != null && e._isAMomentObject != null;
}
function So(e) {
  I.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ze(e, t) {
  var n = !0;
  return Mt(function() {
    if (I.deprecationHandler != null && I.deprecationHandler(null, e), n) {
      var r = [], s, o, i, a = arguments.length;
      for (o = 0; o < a; o++) {
        if (s = "", typeof arguments[o] == "object") {
          s += `
[` + o + "] ";
          for (i in arguments[0])
            te(arguments[0], i) && (s += i + ": " + arguments[0][i] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[o];
        r.push(s);
      }
      So(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Ps = {};
function wo(e, t) {
  I.deprecationHandler != null && I.deprecationHandler(e, t), Ps[e] || (So(t), Ps[e] = !0);
}
I.suppressDeprecationWarnings = !1;
I.deprecationHandler = null;
function ut(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Xa(e) {
  var t, n;
  for (n in e)
    te(e, n) && (t = e[n], ut(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Mr(e, t) {
  var n = Mt({}, e), r;
  for (r in t)
    te(t, r) && (Wt(e[r]) && Wt(t[r]) ? (n[r] = {}, Mt(n[r], e[r]), Mt(n[r], t[r])) : t[r] != null ? n[r] = t[r] : delete n[r]);
  for (r in e)
    te(e, r) && !te(t, r) && Wt(e[r]) && (n[r] = Mt({}, n[r]));
  return n;
}
function Br(e) {
  e != null && this.set(e);
}
var Dr;
Object.keys ? Dr = Object.keys : Dr = function(e) {
  var t, n = [];
  for (t in e)
    te(e, t) && n.push(t);
  return n;
};
var el = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function tl(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return ut(r) ? r.call(t, n) : r;
}
function it(e, t, n) {
  var r = "" + Math.abs(e), s = t - r.length, o = e >= 0;
  return (o ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + r;
}
var $r = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, On = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, _r = {}, jt = {};
function L(e, t, n, r) {
  var s = r;
  typeof r == "string" && (s = function() {
    return this[r]();
  }), e && (jt[e] = s), t && (jt[t[0]] = function() {
    return it(s.apply(this, arguments), t[1], t[2]);
  }), n && (jt[n] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      e
    );
  });
}
function nl(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function rl(e) {
  var t = e.match($r), n, r;
  for (n = 0, r = t.length; n < r; n++)
    jt[t[n]] ? t[n] = jt[t[n]] : t[n] = nl(t[n]);
  return function(s) {
    var o = "", i;
    for (i = 0; i < r; i++)
      o += ut(t[i]) ? t[i].call(s, e) : t[i];
    return o;
  };
}
function En(e, t) {
  return e.isValid() ? (t = vo(t, e.localeData()), _r[t] = _r[t] || rl(t), _r[t](e)) : e.localeData().invalidDate();
}
function vo(e, t) {
  var n = 5;
  function r(s) {
    return t.longDateFormat(s) || s;
  }
  for (On.lastIndex = 0; n >= 0 && On.test(e); )
    e = e.replace(
      On,
      r
    ), On.lastIndex = 0, n -= 1;
  return e;
}
var sl = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function ol(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match($r).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var il = "Invalid date";
function al() {
  return this._invalidDate;
}
var ll = "%d", ul = /\d{1,2}/;
function cl(e) {
  return this._ordinal.replace("%d", e);
}
var dl = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function fl(e, t, n, r) {
  var s = this._relativeTime[n];
  return ut(s) ? s(e, t, n, r) : s.replace(/%d/i, e);
}
function hl(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return ut(n) ? n(t) : n.replace(/%s/i, t);
}
var an = {};
function be(e, t) {
  var n = e.toLowerCase();
  an[n] = an[n + "s"] = an[t] = e;
}
function qe(e) {
  return typeof e == "string" ? an[e] || an[e.toLowerCase()] : void 0;
}
function jr(e) {
  var t = {}, n, r;
  for (r in e)
    te(e, r) && (n = qe(r), n && (t[n] = e[r]));
  return t;
}
var xo = {};
function Oe(e, t) {
  xo[e] = t;
}
function ml(e) {
  var t = [], n;
  for (n in e)
    te(e, n) && t.push({ unit: n, priority: xo[n] });
  return t.sort(function(r, s) {
    return r.priority - s.priority;
  }), t;
}
function Qn(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function $e(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function j(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = $e(t)), n;
}
function Xt(e, t) {
  return function(n) {
    return n != null ? (To(this, e, n), I.updateOffset(this, t), this) : An(this, e);
  };
}
function An(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function To(e, t, n) {
  e.isValid() && !isNaN(n) && (t === "FullYear" && Qn(e.year()) && e.month() === 1 && e.date() === 29 ? (n = j(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    n,
    e.month(),
    sr(n, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
}
function pl(e) {
  return e = qe(e), ut(this[e]) ? this[e]() : this;
}
function gl(e, t) {
  if (typeof e == "object") {
    e = jr(e);
    var n = ml(e), r, s = n.length;
    for (r = 0; r < s; r++)
      this[n[r].unit](e[n[r].unit]);
  } else if (e = qe(e), ut(this[e]))
    return this[e](t);
  return this;
}
var ko = /\d/, Be = /\d\d/, Io = /\d{3}/, Zr = /\d{4}/, Xn = /[+-]?\d{6}/, de = /\d\d?/, Mo = /\d\d\d\d?/, Do = /\d\d\d\d\d\d?/, er = /\d{1,3}/, qr = /\d{1,4}/, tr = /[+-]?\d{1,6}/, en = /\d+/, nr = /[+-]?\d+/, _l = /Z|[+-]\d\d:?\d\d/gi, rr = /Z|[+-]\d\d(?::?\d\d)?/gi, yl = /[+-]?\d+(\.\d{1,3})?/, xn = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Vn;
Vn = {};
function O(e, t, n) {
  Vn[e] = ut(t) ? t : function(r, s) {
    return r && n ? n : t;
  };
}
function Sl(e, t) {
  return te(Vn, e) ? Vn[e](t._strict, t._locale) : new RegExp(wl(e));
}
function wl(e) {
  return Ae(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, r, s, o) {
        return n || r || s || o;
      }
    )
  );
}
function Ae(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var br = {};
function le(e, t) {
  var n, r = t, s;
  for (typeof e == "string" && (e = [e]), yt(t) && (r = function(o, i) {
    i[t] = j(o);
  }), s = e.length, n = 0; n < s; n++)
    br[e[n]] = r;
}
function Tn(e, t) {
  le(e, function(n, r, s, o) {
    s._w = s._w || {}, t(n, s._w, s, o);
  });
}
function vl(e, t, n) {
  t != null && te(br, e) && br[e](t, n._a, n, e);
}
var De = 0, mt = 1, st = 2, xe = 3, Je = 4, pt = 5, Ht = 6, xl = 7, Tl = 8;
function kl(e, t) {
  return (e % t + t) % t;
}
var Se;
Array.prototype.indexOf ? Se = Array.prototype.indexOf : Se = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function sr(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = kl(t, 12);
  return e += (t - n) / 12, n === 1 ? Qn(e) ? 29 : 28 : 31 - n % 7 % 2;
}
L("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
L("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
L("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
be("month", "M");
Oe("month", 8);
O("M", de);
O("MM", de, Be);
O("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
O("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
le(["M", "MM"], function(e, t) {
  t[mt] = j(e) - 1;
});
le(["MMM", "MMMM"], function(e, t, n, r) {
  var s = n._locale.monthsParse(e, r, n._strict);
  s != null ? t[mt] = s : B(n).invalidMonth = e;
});
var Il = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), bo = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Oo = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ml = xn, Dl = xn;
function bl(e, t) {
  return e ? et(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Oo).test(t) ? "format" : "standalone"][e.month()] : et(this._months) ? this._months : this._months.standalone;
}
function Ol(e, t) {
  return e ? et(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Oo.test(t) ? "format" : "standalone"][e.month()] : et(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Cl(e, t, n) {
  var r, s, o, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      o = lt([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        o,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(o, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (s = Se.call(this._shortMonthsParse, i), s !== -1 ? s : null) : (s = Se.call(this._longMonthsParse, i), s !== -1 ? s : null) : t === "MMM" ? (s = Se.call(this._shortMonthsParse, i), s !== -1 ? s : (s = Se.call(this._longMonthsParse, i), s !== -1 ? s : null)) : (s = Se.call(this._longMonthsParse, i), s !== -1 ? s : (s = Se.call(this._shortMonthsParse, i), s !== -1 ? s : null));
}
function Rl(e, t, n) {
  var r, s, o;
  if (this._monthsParseExact)
    return Cl.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (s = lt([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (o = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[r] = new RegExp(o.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (n && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!n && this._monthsParse[r].test(e))
      return r;
  }
}
function Co(e, t) {
  var n;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = j(t);
    else if (t = e.localeData().monthsParse(t), !yt(t))
      return e;
  }
  return n = Math.min(e.date(), sr(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
}
function Ro(e) {
  return e != null ? (Co(this, e), I.updateOffset(this, !0), this) : An(this, "Month");
}
function Yl() {
  return sr(this.year(), this.month());
}
function El(e) {
  return this._monthsParseExact ? (te(this, "_monthsRegex") || Yo.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (te(this, "_monthsShortRegex") || (this._monthsShortRegex = Ml), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Nl(e) {
  return this._monthsParseExact ? (te(this, "_monthsRegex") || Yo.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (te(this, "_monthsRegex") || (this._monthsRegex = Dl), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Yo() {
  function e(i, a) {
    return a.length - i.length;
  }
  var t = [], n = [], r = [], s, o;
  for (s = 0; s < 12; s++)
    o = lt([2e3, s]), t.push(this.monthsShort(o, "")), n.push(this.months(o, "")), r.push(this.months(o, "")), r.push(this.monthsShort(o, ""));
  for (t.sort(e), n.sort(e), r.sort(e), s = 0; s < 12; s++)
    t[s] = Ae(t[s]), n[s] = Ae(n[s]);
  for (s = 0; s < 24; s++)
    r[s] = Ae(r[s]);
  this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
L("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? it(e, 4) : "+" + e;
});
L(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
L(0, ["YYYY", 4], 0, "year");
L(0, ["YYYYY", 5], 0, "year");
L(0, ["YYYYYY", 6, !0], 0, "year");
be("year", "y");
Oe("year", 1);
O("Y", nr);
O("YY", de, Be);
O("YYYY", qr, Zr);
O("YYYYY", tr, Xn);
O("YYYYYY", tr, Xn);
le(["YYYYY", "YYYYYY"], De);
le("YYYY", function(e, t) {
  t[De] = e.length === 2 ? I.parseTwoDigitYear(e) : j(e);
});
le("YY", function(e, t) {
  t[De] = I.parseTwoDigitYear(e);
});
le("Y", function(e, t) {
  t[De] = parseInt(e, 10);
});
function ln(e) {
  return Qn(e) ? 366 : 365;
}
I.parseTwoDigitYear = function(e) {
  return j(e) + (j(e) > 68 ? 1900 : 2e3);
};
var Eo = Xt("FullYear", !0);
function Pl() {
  return Qn(this.year());
}
function Ll(e, t, n, r, s, o, i) {
  var a;
  return e < 100 && e >= 0 ? (a = new Date(e + 400, t, n, r, s, o, i), isFinite(a.getFullYear()) && a.setFullYear(e)) : a = new Date(e, t, n, r, s, o, i), a;
}
function mn(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Un(e, t, n) {
  var r = 7 + t - n, s = (7 + mn(e, 0, r).getUTCDay() - t) % 7;
  return -s + r - 1;
}
function No(e, t, n, r, s) {
  var o = (7 + n - r) % 7, i = Un(e, r, s), a = 1 + 7 * (t - 1) + o + i, l, u;
  return a <= 0 ? (l = e - 1, u = ln(l) + a) : a > ln(e) ? (l = e + 1, u = a - ln(e)) : (l = e, u = a), {
    year: l,
    dayOfYear: u
  };
}
function pn(e, t, n) {
  var r = Un(e.year(), t, n), s = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, o, i;
  return s < 1 ? (i = e.year() - 1, o = s + gt(i, t, n)) : s > gt(e.year(), t, n) ? (o = s - gt(e.year(), t, n), i = e.year() + 1) : (i = e.year(), o = s), {
    week: o,
    year: i
  };
}
function gt(e, t, n) {
  var r = Un(e, t, n), s = Un(e + 1, t, n);
  return (ln(e) - r + s) / 7;
}
L("w", ["ww", 2], "wo", "week");
L("W", ["WW", 2], "Wo", "isoWeek");
be("week", "w");
be("isoWeek", "W");
Oe("week", 5);
Oe("isoWeek", 5);
O("w", de);
O("ww", de, Be);
O("W", de);
O("WW", de, Be);
Tn(
  ["w", "ww", "W", "WW"],
  function(e, t, n, r) {
    t[r.substr(0, 1)] = j(e);
  }
);
function Hl(e) {
  return pn(e, this._week.dow, this._week.doy).week;
}
var Wl = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Fl() {
  return this._week.dow;
}
function Al() {
  return this._week.doy;
}
function Vl(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Ul(e) {
  var t = pn(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
L("d", 0, "do", "day");
L("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
L("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
L("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
L("e", 0, 0, "weekday");
L("E", 0, 0, "isoWeekday");
be("day", "d");
be("weekday", "e");
be("isoWeekday", "E");
Oe("day", 11);
Oe("weekday", 11);
Oe("isoWeekday", 11);
O("d", de);
O("e", de);
O("E", de);
O("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
O("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
O("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Tn(["dd", "ddd", "dddd"], function(e, t, n, r) {
  var s = n._locale.weekdaysParse(e, r, n._strict);
  s != null ? t.d = s : B(n).invalidWeekday = e;
});
Tn(["d", "e", "E"], function(e, t, n, r) {
  t[r] = j(e);
});
function Gl(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function zl(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Kr(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Bl = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Po = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), $l = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), jl = xn, Zl = xn, ql = xn;
function Kl(e, t) {
  var n = et(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Kr(n, this._week.dow) : e ? n[e.day()] : n;
}
function Jl(e) {
  return e === !0 ? Kr(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Ql(e) {
  return e === !0 ? Kr(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Xl(e, t, n) {
  var r, s, o, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      o = lt([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        o,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        o,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(o, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (s = Se.call(this._weekdaysParse, i), s !== -1 ? s : null) : t === "ddd" ? (s = Se.call(this._shortWeekdaysParse, i), s !== -1 ? s : null) : (s = Se.call(this._minWeekdaysParse, i), s !== -1 ? s : null) : t === "dddd" ? (s = Se.call(this._weekdaysParse, i), s !== -1 || (s = Se.call(this._shortWeekdaysParse, i), s !== -1) ? s : (s = Se.call(this._minWeekdaysParse, i), s !== -1 ? s : null)) : t === "ddd" ? (s = Se.call(this._shortWeekdaysParse, i), s !== -1 || (s = Se.call(this._weekdaysParse, i), s !== -1) ? s : (s = Se.call(this._minWeekdaysParse, i), s !== -1 ? s : null)) : (s = Se.call(this._minWeekdaysParse, i), s !== -1 || (s = Se.call(this._weekdaysParse, i), s !== -1) ? s : (s = Se.call(this._shortWeekdaysParse, i), s !== -1 ? s : null));
}
function eu(e, t, n) {
  var r, s, o;
  if (this._weekdaysParseExact)
    return Xl.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (s = lt([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (o = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[r] = new RegExp(o.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (n && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (n && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!n && this._weekdaysParse[r].test(e))
      return r;
  }
}
function tu(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Gl(e, this.localeData()), this.add(e - t, "d")) : t;
}
function nu(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function ru(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = zl(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function su(e) {
  return this._weekdaysParseExact ? (te(this, "_weekdaysRegex") || Jr.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (te(this, "_weekdaysRegex") || (this._weekdaysRegex = jl), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function ou(e) {
  return this._weekdaysParseExact ? (te(this, "_weekdaysRegex") || Jr.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (te(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Zl), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function iu(e) {
  return this._weekdaysParseExact ? (te(this, "_weekdaysRegex") || Jr.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (te(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = ql), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Jr() {
  function e(c, p) {
    return p.length - c.length;
  }
  var t = [], n = [], r = [], s = [], o, i, a, l, u;
  for (o = 0; o < 7; o++)
    i = lt([2e3, 1]).day(o), a = Ae(this.weekdaysMin(i, "")), l = Ae(this.weekdaysShort(i, "")), u = Ae(this.weekdays(i, "")), t.push(a), n.push(l), r.push(u), s.push(a), s.push(l), s.push(u);
  t.sort(e), n.sort(e), r.sort(e), s.sort(e), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Qr() {
  return this.hours() % 12 || 12;
}
function au() {
  return this.hours() || 24;
}
L("H", ["HH", 2], 0, "hour");
L("h", ["hh", 2], 0, Qr);
L("k", ["kk", 2], 0, au);
L("hmm", 0, 0, function() {
  return "" + Qr.apply(this) + it(this.minutes(), 2);
});
L("hmmss", 0, 0, function() {
  return "" + Qr.apply(this) + it(this.minutes(), 2) + it(this.seconds(), 2);
});
L("Hmm", 0, 0, function() {
  return "" + this.hours() + it(this.minutes(), 2);
});
L("Hmmss", 0, 0, function() {
  return "" + this.hours() + it(this.minutes(), 2) + it(this.seconds(), 2);
});
function Lo(e, t) {
  L(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
Lo("a", !0);
Lo("A", !1);
be("hour", "h");
Oe("hour", 13);
function Ho(e, t) {
  return t._meridiemParse;
}
O("a", Ho);
O("A", Ho);
O("H", de);
O("h", de);
O("k", de);
O("HH", de, Be);
O("hh", de, Be);
O("kk", de, Be);
O("hmm", Mo);
O("hmmss", Do);
O("Hmm", Mo);
O("Hmmss", Do);
le(["H", "HH"], xe);
le(["k", "kk"], function(e, t, n) {
  var r = j(e);
  t[xe] = r === 24 ? 0 : r;
});
le(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
le(["h", "hh"], function(e, t, n) {
  t[xe] = j(e), B(n).bigHour = !0;
});
le("hmm", function(e, t, n) {
  var r = e.length - 2;
  t[xe] = j(e.substr(0, r)), t[Je] = j(e.substr(r)), B(n).bigHour = !0;
});
le("hmmss", function(e, t, n) {
  var r = e.length - 4, s = e.length - 2;
  t[xe] = j(e.substr(0, r)), t[Je] = j(e.substr(r, 2)), t[pt] = j(e.substr(s)), B(n).bigHour = !0;
});
le("Hmm", function(e, t, n) {
  var r = e.length - 2;
  t[xe] = j(e.substr(0, r)), t[Je] = j(e.substr(r));
});
le("Hmmss", function(e, t, n) {
  var r = e.length - 4, s = e.length - 2;
  t[xe] = j(e.substr(0, r)), t[Je] = j(e.substr(r, 2)), t[pt] = j(e.substr(s));
});
function lu(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var uu = /[ap]\.?m?\.?/i, cu = Xt("Hours", !0);
function du(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var Wo = {
  calendar: el,
  longDateFormat: sl,
  invalidDate: il,
  ordinal: ll,
  dayOfMonthOrdinalParse: ul,
  relativeTime: dl,
  months: Il,
  monthsShort: bo,
  week: Wl,
  weekdays: Bl,
  weekdaysMin: $l,
  weekdaysShort: Po,
  meridiemParse: uu
}, fe = {}, nn = {}, gn;
function fu(e, t) {
  var n, r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1)
    if (e[n] !== t[n])
      return n;
  return r;
}
function Ls(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function hu(e) {
  for (var t = 0, n, r, s, o; t < e.length; ) {
    for (o = Ls(e[t]).split("-"), n = o.length, r = Ls(e[t + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (s = or(o.slice(0, n).join("-")), s)
        return s;
      if (r && r.length >= n && fu(o, r) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return gn;
}
function mu(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function or(e) {
  var t = null, n;
  if (fe[e] === void 0 && typeof module < "u" && module && module.exports && mu(e))
    try {
      t = gn._abbr, n = require, n("./locale/" + e), bt(t);
    } catch {
      fe[e] = null;
    }
  return fe[e];
}
function bt(e, t) {
  var n;
  return e && (Ne(t) ? n = St(e) : n = Xr(e, t), n ? gn = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), gn._abbr;
}
function Xr(e, t) {
  if (t !== null) {
    var n, r = Wo;
    if (t.abbr = e, fe[e] != null)
      wo(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = fe[e]._config;
    else if (t.parentLocale != null)
      if (fe[t.parentLocale] != null)
        r = fe[t.parentLocale]._config;
      else if (n = or(t.parentLocale), n != null)
        r = n._config;
      else
        return nn[t.parentLocale] || (nn[t.parentLocale] = []), nn[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return fe[e] = new Br(Mr(r, t)), nn[e] && nn[e].forEach(function(s) {
      Xr(s.name, s.config);
    }), bt(e), fe[e];
  } else
    return delete fe[e], null;
}
function pu(e, t) {
  if (t != null) {
    var n, r, s = Wo;
    fe[e] != null && fe[e].parentLocale != null ? fe[e].set(Mr(fe[e]._config, t)) : (r = or(e), r != null && (s = r._config), t = Mr(s, t), r == null && (t.abbr = e), n = new Br(t), n.parentLocale = fe[e], fe[e] = n), bt(e);
  } else
    fe[e] != null && (fe[e].parentLocale != null ? (fe[e] = fe[e].parentLocale, e === bt() && bt(e)) : fe[e] != null && delete fe[e]);
  return fe[e];
}
function St(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return gn;
  if (!et(e)) {
    if (t = or(e), t)
      return t;
    e = [e];
  }
  return hu(e);
}
function gu() {
  return Dr(fe);
}
function es(e) {
  var t, n = e._a;
  return n && B(e).overflow === -2 && (t = n[mt] < 0 || n[mt] > 11 ? mt : n[st] < 1 || n[st] > sr(n[De], n[mt]) ? st : n[xe] < 0 || n[xe] > 24 || n[xe] === 24 && (n[Je] !== 0 || n[pt] !== 0 || n[Ht] !== 0) ? xe : n[Je] < 0 || n[Je] > 59 ? Je : n[pt] < 0 || n[pt] > 59 ? pt : n[Ht] < 0 || n[Ht] > 999 ? Ht : -1, B(e)._overflowDayOfYear && (t < De || t > st) && (t = st), B(e)._overflowWeeks && t === -1 && (t = xl), B(e)._overflowWeekday && t === -1 && (t = Tl), B(e).overflow = t), e;
}
var _u = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, yu = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Su = /Z|[+-]\d\d(?::?\d\d)?/, Cn = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], yr = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], wu = /^\/?Date\((-?\d+)/i, vu = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, xu = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Fo(e) {
  var t, n, r = e._i, s = _u.exec(r) || yu.exec(r), o, i, a, l, u = Cn.length, c = yr.length;
  if (s) {
    for (B(e).iso = !0, t = 0, n = u; t < n; t++)
      if (Cn[t][1].exec(s[1])) {
        i = Cn[t][0], o = Cn[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (s[3]) {
      for (t = 0, n = c; t < n; t++)
        if (yr[t][1].exec(s[3])) {
          a = (s[2] || " ") + yr[t][0];
          break;
        }
      if (a == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!o && a != null) {
      e._isValid = !1;
      return;
    }
    if (s[4])
      if (Su.exec(s[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (a || "") + (l || ""), ns(e);
  } else
    e._isValid = !1;
}
function Tu(e, t, n, r, s, o) {
  var i = [
    ku(e),
    bo.indexOf(t),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(s, 10)
  ];
  return o && i.push(parseInt(o, 10)), i;
}
function ku(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Iu(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Mu(e, t, n) {
  if (e) {
    var r = Po.indexOf(e), s = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== s)
      return B(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function Du(e, t, n) {
  if (e)
    return xu[e];
  if (t)
    return 0;
  var r = parseInt(n, 10), s = r % 100, o = (r - s) / 100;
  return o * 60 + s;
}
function Ao(e) {
  var t = vu.exec(Iu(e._i)), n;
  if (t) {
    if (n = Tu(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Mu(t[1], n, e))
      return;
    e._a = n, e._tzm = Du(t[8], t[9], t[10]), e._d = mn.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), B(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function bu(e) {
  var t = wu.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (Fo(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Ao(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : I.createFromInputFallback(e);
}
I.createFromInputFallback = Ze(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function zt(e, t, n) {
  return e ?? t ?? n;
}
function Ou(e) {
  var t = new Date(I.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function ts(e) {
  var t, n, r = [], s, o, i;
  if (!e._d) {
    for (s = Ou(e), e._w && e._a[st] == null && e._a[mt] == null && Cu(e), e._dayOfYear != null && (i = zt(e._a[De], s[De]), (e._dayOfYear > ln(i) || e._dayOfYear === 0) && (B(e)._overflowDayOfYear = !0), n = mn(i, 0, e._dayOfYear), e._a[mt] = n.getUTCMonth(), e._a[st] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = s[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[xe] === 24 && e._a[Je] === 0 && e._a[pt] === 0 && e._a[Ht] === 0 && (e._nextDay = !0, e._a[xe] = 0), e._d = (e._useUTC ? mn : Ll).apply(
      null,
      r
    ), o = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[xe] = 24), e._w && typeof e._w.d < "u" && e._w.d !== o && (B(e).weekdayMismatch = !0);
  }
}
function Cu(e) {
  var t, n, r, s, o, i, a, l, u;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (o = 1, i = 4, n = zt(
    t.GG,
    e._a[De],
    pn(ce(), 1, 4).year
  ), r = zt(t.W, 1), s = zt(t.E, 1), (s < 1 || s > 7) && (l = !0)) : (o = e._locale._week.dow, i = e._locale._week.doy, u = pn(ce(), o, i), n = zt(t.gg, e._a[De], u.year), r = zt(t.w, u.week), t.d != null ? (s = t.d, (s < 0 || s > 6) && (l = !0)) : t.e != null ? (s = t.e + o, (t.e < 0 || t.e > 6) && (l = !0)) : s = o), r < 1 || r > gt(n, o, i) ? B(e)._overflowWeeks = !0 : l != null ? B(e)._overflowWeekday = !0 : (a = No(n, r, s, o, i), e._a[De] = a.year, e._dayOfYear = a.dayOfYear);
}
I.ISO_8601 = function() {
};
I.RFC_2822 = function() {
};
function ns(e) {
  if (e._f === I.ISO_8601) {
    Fo(e);
    return;
  }
  if (e._f === I.RFC_2822) {
    Ao(e);
    return;
  }
  e._a = [], B(e).empty = !0;
  var t = "" + e._i, n, r, s, o, i, a = t.length, l = 0, u, c;
  for (s = vo(e._f, e._locale).match($r) || [], c = s.length, n = 0; n < c; n++)
    o = s[n], r = (t.match(Sl(o, e)) || [])[0], r && (i = t.substr(0, t.indexOf(r)), i.length > 0 && B(e).unusedInput.push(i), t = t.slice(
      t.indexOf(r) + r.length
    ), l += r.length), jt[o] ? (r ? B(e).empty = !1 : B(e).unusedTokens.push(o), vl(o, r, e)) : e._strict && !r && B(e).unusedTokens.push(o);
  B(e).charsLeftOver = a - l, t.length > 0 && B(e).unusedInput.push(t), e._a[xe] <= 12 && B(e).bigHour === !0 && e._a[xe] > 0 && (B(e).bigHour = void 0), B(e).parsedDateParts = e._a.slice(0), B(e).meridiem = e._meridiem, e._a[xe] = Ru(
    e._locale,
    e._a[xe],
    e._meridiem
  ), u = B(e).era, u !== null && (e._a[De] = e._locale.erasConvertYear(u, e._a[De])), ts(e), es(e);
}
function Ru(e, t, n) {
  var r;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (r = e.isPM(n), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function Yu(e) {
  var t, n, r, s, o, i, a = !1, l = e._f.length;
  if (l === 0) {
    B(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < l; s++)
    o = 0, i = !1, t = zr({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[s], ns(t), Gr(t) && (i = !0), o += B(t).charsLeftOver, o += B(t).unusedTokens.length * 10, B(t).score = o, a ? o < r && (r = o, n = t) : (r == null || o < r || i) && (r = o, n = t, i && (a = !0));
  Mt(e, n || t);
}
function Eu(e) {
  if (!e._d) {
    var t = jr(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = yo(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), ts(e);
  }
}
function Nu(e) {
  var t = new vn(es(Vo(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Vo(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || St(e._l), t === null || n === void 0 && t === "" ? Jn({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), tt(t) ? new vn(es(t)) : (wn(t) ? e._d = t : et(n) ? Yu(e) : n ? ns(e) : Pu(e), Gr(e) || (e._d = null), e));
}
function Pu(e) {
  var t = e._i;
  Ne(t) ? e._d = new Date(I.now()) : wn(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? bu(e) : et(t) ? (e._a = yo(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), ts(e)) : Wt(t) ? Eu(e) : yt(t) ? e._d = new Date(t) : I.createFromInputFallback(e);
}
function Uo(e, t, n, r, s) {
  var o = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (Wt(e) && Ur(e) || et(e) && e.length === 0) && (e = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = s, o._l = n, o._i = e, o._f = t, o._strict = r, Nu(o);
}
function ce(e, t, n, r) {
  return Uo(e, t, n, r, !1);
}
var Lu = Ze(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = ce.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Jn();
  }
), Hu = Ze(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = ce.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Jn();
  }
);
function Go(e, t) {
  var n, r;
  if (t.length === 1 && et(t[0]) && (t = t[0]), !t.length)
    return ce();
  for (n = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function Wu() {
  var e = [].slice.call(arguments, 0);
  return Go("isBefore", e);
}
function Fu() {
  var e = [].slice.call(arguments, 0);
  return Go("isAfter", e);
}
var Au = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, rn = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Vu(e) {
  var t, n = !1, r, s = rn.length;
  for (t in e)
    if (te(e, t) && !(Se.call(rn, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < s; ++r)
    if (e[rn[r]]) {
      if (n)
        return !1;
      parseFloat(e[rn[r]]) !== j(e[rn[r]]) && (n = !0);
    }
  return !0;
}
function Uu() {
  return this._isValid;
}
function Gu() {
  return nt(NaN);
}
function ir(e) {
  var t = jr(e), n = t.year || 0, r = t.quarter || 0, s = t.month || 0, o = t.week || t.isoWeek || 0, i = t.day || 0, a = t.hour || 0, l = t.minute || 0, u = t.second || 0, c = t.millisecond || 0;
  this._isValid = Vu(t), this._milliseconds = +c + u * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  a * 1e3 * 60 * 60, this._days = +i + o * 7, this._months = +s + r * 3 + n * 12, this._data = {}, this._locale = St(), this._bubble();
}
function Nn(e) {
  return e instanceof ir;
}
function Or(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function zu(e, t, n) {
  var r = Math.min(e.length, t.length), s = Math.abs(e.length - t.length), o = 0, i;
  for (i = 0; i < r; i++)
    (n && e[i] !== t[i] || !n && j(e[i]) !== j(t[i])) && o++;
  return o + s;
}
function zo(e, t) {
  L(e, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + it(~~(n / 60), 2) + t + it(~~n % 60, 2);
  });
}
zo("Z", ":");
zo("ZZ", "");
O("Z", rr);
O("ZZ", rr);
le(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = rs(rr, e);
});
var Bu = /([\+\-]|\d\d)/gi;
function rs(e, t) {
  var n = (t || "").match(e), r, s, o;
  return n === null ? null : (r = n[n.length - 1] || [], s = (r + "").match(Bu) || ["-", 0, 0], o = +(s[1] * 60) + j(s[2]), o === 0 ? 0 : s[0] === "+" ? o : -o);
}
function ss(e, t) {
  var n, r;
  return t._isUTC ? (n = t.clone(), r = (tt(e) || wn(e) ? e.valueOf() : ce(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), I.updateOffset(n, !1), n) : ce(e).local();
}
function Cr(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
I.updateOffset = function() {
};
function $u(e, t, n) {
  var r = this._offset || 0, s;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = rs(rr, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (s = Cr(this)), this._offset = e, this._isUTC = !0, s != null && this.add(s, "m"), r !== e && (!t || this._changeInProgress ? jo(
      this,
      nt(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, I.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : Cr(this);
}
function ju(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Zu(e) {
  return this.utcOffset(0, e);
}
function qu(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Cr(this), "m")), this;
}
function Ku() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = rs(_l, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Ju(e) {
  return this.isValid() ? (e = e ? ce(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Qu() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Xu() {
  if (!Ne(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return zr(e, this), e = Vo(e), e._a ? (t = e._isUTC ? lt(e._a) : ce(e._a), this._isDSTShifted = this.isValid() && zu(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function ec() {
  return this.isValid() ? !this._isUTC : !1;
}
function tc() {
  return this.isValid() ? this._isUTC : !1;
}
function Bo() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var nc = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, rc = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function nt(e, t) {
  var n = e, r = null, s, o, i;
  return Nn(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : yt(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (r = nc.exec(e)) ? (s = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: j(r[st]) * s,
    h: j(r[xe]) * s,
    m: j(r[Je]) * s,
    s: j(r[pt]) * s,
    ms: j(Or(r[Ht] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (r = rc.exec(e)) ? (s = r[1] === "-" ? -1 : 1, n = {
    y: Pt(r[2], s),
    M: Pt(r[3], s),
    w: Pt(r[4], s),
    d: Pt(r[5], s),
    h: Pt(r[6], s),
    m: Pt(r[7], s),
    s: Pt(r[8], s)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (i = sc(
    ce(n.from),
    ce(n.to)
  ), n = {}, n.ms = i.milliseconds, n.M = i.months), o = new ir(n), Nn(e) && te(e, "_locale") && (o._locale = e._locale), Nn(e) && te(e, "_isValid") && (o._isValid = e._isValid), o;
}
nt.fn = ir.prototype;
nt.invalid = Gu;
function Pt(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function Hs(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function sc(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = ss(t, e), e.isBefore(t) ? n = Hs(e, t) : (n = Hs(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function $o(e, t) {
  return function(n, r) {
    var s, o;
    return r !== null && !isNaN(+r) && (wo(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), o = n, n = r, r = o), s = nt(n, r), jo(this, s, e), this;
  };
}
function jo(e, t, n, r) {
  var s = t._milliseconds, o = Or(t._days), i = Or(t._months);
  e.isValid() && (r = r ?? !0, i && Co(e, An(e, "Month") + i * n), o && To(e, "Date", An(e, "Date") + o * n), s && e._d.setTime(e._d.valueOf() + s * n), r && I.updateOffset(e, o || i));
}
var oc = $o(1, "add"), ic = $o(-1, "subtract");
function Zo(e) {
  return typeof e == "string" || e instanceof String;
}
function ac(e) {
  return tt(e) || wn(e) || Zo(e) || yt(e) || uc(e) || lc(e) || e === null || e === void 0;
}
function lc(e) {
  var t = Wt(e) && !Ur(e), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, o, i = r.length;
  for (s = 0; s < i; s += 1)
    o = r[s], n = n || te(e, o);
  return t && n;
}
function uc(e) {
  var t = et(e), n = !1;
  return t && (n = e.filter(function(r) {
    return !yt(r) && Zo(e);
  }).length === 0), t && n;
}
function cc(e) {
  var t = Wt(e) && !Ur(e), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, o;
  for (s = 0; s < r.length; s += 1)
    o = r[s], n = n || te(e, o);
  return t && n;
}
function dc(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function fc(e, t) {
  arguments.length === 1 && (arguments[0] ? ac(arguments[0]) ? (e = arguments[0], t = void 0) : cc(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || ce(), r = ss(n, this).startOf("day"), s = I.calendarFormat(this, r) || "sameElse", o = t && (ut(t[s]) ? t[s].call(this, n) : t[s]);
  return this.format(
    o || this.localeData().calendar(s, this, ce(n))
  );
}
function hc() {
  return new vn(this);
}
function mc(e, t) {
  var n = tt(e) ? e : ce(e);
  return this.isValid() && n.isValid() ? (t = qe(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function pc(e, t) {
  var n = tt(e) ? e : ce(e);
  return this.isValid() && n.isValid() ? (t = qe(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function gc(e, t, n, r) {
  var s = tt(e) ? e : ce(e), o = tt(t) ? t : ce(t);
  return this.isValid() && s.isValid() && o.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(s, n) : !this.isBefore(s, n)) && (r[1] === ")" ? this.isBefore(o, n) : !this.isAfter(o, n))) : !1;
}
function _c(e, t) {
  var n = tt(e) ? e : ce(e), r;
  return this.isValid() && n.isValid() ? (t = qe(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function yc(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Sc(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function wc(e, t, n) {
  var r, s, o;
  if (!this.isValid())
    return NaN;
  if (r = ss(e, this), !r.isValid())
    return NaN;
  switch (s = (r.utcOffset() - this.utcOffset()) * 6e4, t = qe(t), t) {
    case "year":
      o = Pn(this, r) / 12;
      break;
    case "month":
      o = Pn(this, r);
      break;
    case "quarter":
      o = Pn(this, r) / 3;
      break;
    case "second":
      o = (this - r) / 1e3;
      break;
    case "minute":
      o = (this - r) / 6e4;
      break;
    case "hour":
      o = (this - r) / 36e5;
      break;
    case "day":
      o = (this - r - s) / 864e5;
      break;
    case "week":
      o = (this - r - s) / 6048e5;
      break;
    default:
      o = this - r;
  }
  return n ? o : $e(o);
}
function Pn(e, t) {
  if (e.date() < t.date())
    return -Pn(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(n, "months"), s, o;
  return t - r < 0 ? (s = e.clone().add(n - 1, "months"), o = (t - r) / (r - s)) : (s = e.clone().add(n + 1, "months"), o = (t - r) / (s - r)), -(n + o) || 0;
}
I.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
I.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function vc() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function xc(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? En(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ut(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", En(n, "Z")) : En(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Tc() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, r, s, o;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", o = t + '[")]', this.format(n + r + s + o);
}
function kc(e) {
  e || (e = this.isUtc() ? I.defaultFormatUtc : I.defaultFormat);
  var t = En(this, e);
  return this.localeData().postformat(t);
}
function Ic(e, t) {
  return this.isValid() && (tt(e) && e.isValid() || ce(e).isValid()) ? nt({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Mc(e) {
  return this.from(ce(), e);
}
function Dc(e, t) {
  return this.isValid() && (tt(e) && e.isValid() || ce(e).isValid()) ? nt({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function bc(e) {
  return this.to(ce(), e);
}
function qo(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = St(e), t != null && (this._locale = t), this);
}
var Ko = Ze(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Jo() {
  return this._locale;
}
var Gn = 1e3, Zt = 60 * Gn, zn = 60 * Zt, Qo = (365 * 400 + 97) * 24 * zn;
function qt(e, t) {
  return (e % t + t) % t;
}
function Xo(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - Qo : new Date(e, t, n).valueOf();
}
function ei(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - Qo : Date.UTC(e, t, n);
}
function Oc(e) {
  var t, n;
  if (e = qe(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? ei : Xo, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= qt(
        t + (this._isUTC ? 0 : this.utcOffset() * Zt),
        zn
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= qt(t, Zt);
      break;
    case "second":
      t = this._d.valueOf(), t -= qt(t, Gn);
      break;
  }
  return this._d.setTime(t), I.updateOffset(this, !0), this;
}
function Cc(e) {
  var t, n;
  if (e = qe(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? ei : Xo, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += zn - qt(
        t + (this._isUTC ? 0 : this.utcOffset() * Zt),
        zn
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Zt - qt(t, Zt) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Gn - qt(t, Gn) - 1;
      break;
  }
  return this._d.setTime(t), I.updateOffset(this, !0), this;
}
function Rc() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Yc() {
  return Math.floor(this.valueOf() / 1e3);
}
function Ec() {
  return new Date(this.valueOf());
}
function Nc() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Pc() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Lc() {
  return this.isValid() ? this.toISOString() : null;
}
function Hc() {
  return Gr(this);
}
function Wc() {
  return Mt({}, B(this));
}
function Fc() {
  return B(this).overflow;
}
function Ac() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
L("N", 0, 0, "eraAbbr");
L("NN", 0, 0, "eraAbbr");
L("NNN", 0, 0, "eraAbbr");
L("NNNN", 0, 0, "eraName");
L("NNNNN", 0, 0, "eraNarrow");
L("y", ["y", 1], "yo", "eraYear");
L("y", ["yy", 2], 0, "eraYear");
L("y", ["yyy", 3], 0, "eraYear");
L("y", ["yyyy", 4], 0, "eraYear");
O("N", os);
O("NN", os);
O("NNN", os);
O("NNNN", Jc);
O("NNNNN", Qc);
le(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, r) {
    var s = n._locale.erasParse(e, r, n._strict);
    s ? B(n).era = s : B(n).invalidEra = e;
  }
);
O("y", en);
O("yy", en);
O("yyy", en);
O("yyyy", en);
O("yo", Xc);
le(["y", "yy", "yyy", "yyyy"], De);
le(["yo"], function(e, t, n, r) {
  var s;
  n._locale._eraYearOrdinalRegex && (s = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[De] = n._locale.eraYearOrdinalParse(e, s) : t[De] = parseInt(e, 10);
});
function Vc(e, t) {
  var n, r, s, o = this._eras || St("en")._eras;
  for (n = 0, r = o.length; n < r; ++n) {
    switch (typeof o[n].since) {
      case "string":
        s = I(o[n].since).startOf("day"), o[n].since = s.valueOf();
        break;
    }
    switch (typeof o[n].until) {
      case "undefined":
        o[n].until = 1 / 0;
        break;
      case "string":
        s = I(o[n].until).startOf("day").valueOf(), o[n].until = s.valueOf();
        break;
    }
  }
  return o;
}
function Uc(e, t, n) {
  var r, s, o = this.eras(), i, a, l;
  for (e = e.toUpperCase(), r = 0, s = o.length; r < s; ++r)
    if (i = o[r].name.toUpperCase(), a = o[r].abbr.toUpperCase(), l = o[r].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (a === e)
            return o[r];
          break;
        case "NNNN":
          if (i === e)
            return o[r];
          break;
        case "NNNNN":
          if (l === e)
            return o[r];
          break;
      }
    else if ([i, a, l].indexOf(e) >= 0)
      return o[r];
}
function Gc(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? I(e.since).year() : I(e.since).year() + (t - e.offset) * n;
}
function zc() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].name;
  return "";
}
function Bc() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].narrow;
  return "";
}
function $c() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].abbr;
  return "";
}
function jc() {
  var e, t, n, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (n = s[e].since <= s[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return (this.year() - I(s[e].since).year()) * n + s[e].offset;
  return this.year();
}
function Zc(e) {
  return te(this, "_erasNameRegex") || is.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function qc(e) {
  return te(this, "_erasAbbrRegex") || is.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Kc(e) {
  return te(this, "_erasNarrowRegex") || is.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function os(e, t) {
  return t.erasAbbrRegex(e);
}
function Jc(e, t) {
  return t.erasNameRegex(e);
}
function Qc(e, t) {
  return t.erasNarrowRegex(e);
}
function Xc(e, t) {
  return t._eraYearOrdinalRegex || en;
}
function is() {
  var e = [], t = [], n = [], r = [], s, o, i = this.eras();
  for (s = 0, o = i.length; s < o; ++s)
    t.push(Ae(i[s].name)), e.push(Ae(i[s].abbr)), n.push(Ae(i[s].narrow)), r.push(Ae(i[s].name)), r.push(Ae(i[s].abbr)), r.push(Ae(i[s].narrow));
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
L(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
L(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function ar(e, t) {
  L(0, [e, e.length], 0, t);
}
ar("gggg", "weekYear");
ar("ggggg", "weekYear");
ar("GGGG", "isoWeekYear");
ar("GGGGG", "isoWeekYear");
be("weekYear", "gg");
be("isoWeekYear", "GG");
Oe("weekYear", 1);
Oe("isoWeekYear", 1);
O("G", nr);
O("g", nr);
O("GG", de, Be);
O("gg", de, Be);
O("GGGG", qr, Zr);
O("gggg", qr, Zr);
O("GGGGG", tr, Xn);
O("ggggg", tr, Xn);
Tn(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, r) {
    t[r.substr(0, 2)] = j(e);
  }
);
Tn(["gg", "GG"], function(e, t, n, r) {
  t[r] = I.parseTwoDigitYear(e);
});
function ed(e) {
  return ti.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function td(e) {
  return ti.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function nd() {
  return gt(this.year(), 1, 4);
}
function rd() {
  return gt(this.isoWeekYear(), 1, 4);
}
function sd() {
  var e = this.localeData()._week;
  return gt(this.year(), e.dow, e.doy);
}
function od() {
  var e = this.localeData()._week;
  return gt(this.weekYear(), e.dow, e.doy);
}
function ti(e, t, n, r, s) {
  var o;
  return e == null ? pn(this, r, s).year : (o = gt(e, r, s), t > o && (t = o), id.call(this, e, t, n, r, s));
}
function id(e, t, n, r, s) {
  var o = No(e, t, n, r, s), i = mn(o.year, 0, o.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
L("Q", 0, "Qo", "quarter");
be("quarter", "Q");
Oe("quarter", 7);
O("Q", ko);
le("Q", function(e, t) {
  t[mt] = (j(e) - 1) * 3;
});
function ad(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
L("D", ["DD", 2], "Do", "date");
be("date", "D");
Oe("date", 9);
O("D", de);
O("DD", de, Be);
O("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
le(["D", "DD"], st);
le("Do", function(e, t) {
  t[st] = j(e.match(de)[0]);
});
var ni = Xt("Date", !0);
L("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
be("dayOfYear", "DDD");
Oe("dayOfYear", 4);
O("DDD", er);
O("DDDD", Io);
le(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = j(e);
});
function ld(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
L("m", ["mm", 2], 0, "minute");
be("minute", "m");
Oe("minute", 14);
O("m", de);
O("mm", de, Be);
le(["m", "mm"], Je);
var ud = Xt("Minutes", !1);
L("s", ["ss", 2], 0, "second");
be("second", "s");
Oe("second", 15);
O("s", de);
O("ss", de, Be);
le(["s", "ss"], pt);
var cd = Xt("Seconds", !1);
L("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
L(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
L(0, ["SSS", 3], 0, "millisecond");
L(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
L(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
L(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
L(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
L(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
L(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
be("millisecond", "ms");
Oe("millisecond", 16);
O("S", er, ko);
O("SS", er, Be);
O("SSS", er, Io);
var Dt, ri;
for (Dt = "SSSS"; Dt.length <= 9; Dt += "S")
  O(Dt, en);
function dd(e, t) {
  t[Ht] = j(("0." + e) * 1e3);
}
for (Dt = "S"; Dt.length <= 9; Dt += "S")
  le(Dt, dd);
ri = Xt("Milliseconds", !1);
L("z", 0, 0, "zoneAbbr");
L("zz", 0, 0, "zoneName");
function fd() {
  return this._isUTC ? "UTC" : "";
}
function hd() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var S = vn.prototype;
S.add = oc;
S.calendar = fc;
S.clone = hc;
S.diff = wc;
S.endOf = Cc;
S.format = kc;
S.from = Ic;
S.fromNow = Mc;
S.to = Dc;
S.toNow = bc;
S.get = pl;
S.invalidAt = Fc;
S.isAfter = mc;
S.isBefore = pc;
S.isBetween = gc;
S.isSame = _c;
S.isSameOrAfter = yc;
S.isSameOrBefore = Sc;
S.isValid = Hc;
S.lang = Ko;
S.locale = qo;
S.localeData = Jo;
S.max = Hu;
S.min = Lu;
S.parsingFlags = Wc;
S.set = gl;
S.startOf = Oc;
S.subtract = ic;
S.toArray = Nc;
S.toObject = Pc;
S.toDate = Ec;
S.toISOString = xc;
S.inspect = Tc;
typeof Symbol < "u" && Symbol.for != null && (S[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
S.toJSON = Lc;
S.toString = vc;
S.unix = Yc;
S.valueOf = Rc;
S.creationData = Ac;
S.eraName = zc;
S.eraNarrow = Bc;
S.eraAbbr = $c;
S.eraYear = jc;
S.year = Eo;
S.isLeapYear = Pl;
S.weekYear = ed;
S.isoWeekYear = td;
S.quarter = S.quarters = ad;
S.month = Ro;
S.daysInMonth = Yl;
S.week = S.weeks = Vl;
S.isoWeek = S.isoWeeks = Ul;
S.weeksInYear = sd;
S.weeksInWeekYear = od;
S.isoWeeksInYear = nd;
S.isoWeeksInISOWeekYear = rd;
S.date = ni;
S.day = S.days = tu;
S.weekday = nu;
S.isoWeekday = ru;
S.dayOfYear = ld;
S.hour = S.hours = cu;
S.minute = S.minutes = ud;
S.second = S.seconds = cd;
S.millisecond = S.milliseconds = ri;
S.utcOffset = $u;
S.utc = Zu;
S.local = qu;
S.parseZone = Ku;
S.hasAlignedHourOffset = Ju;
S.isDST = Qu;
S.isLocal = ec;
S.isUtcOffset = tc;
S.isUtc = Bo;
S.isUTC = Bo;
S.zoneAbbr = fd;
S.zoneName = hd;
S.dates = Ze(
  "dates accessor is deprecated. Use date instead.",
  ni
);
S.months = Ze(
  "months accessor is deprecated. Use month instead",
  Ro
);
S.years = Ze(
  "years accessor is deprecated. Use year instead",
  Eo
);
S.zone = Ze(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  ju
);
S.isDSTShifted = Ze(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Xu
);
function md(e) {
  return ce(e * 1e3);
}
function pd() {
  return ce.apply(null, arguments).parseZone();
}
function si(e) {
  return e;
}
var ne = Br.prototype;
ne.calendar = tl;
ne.longDateFormat = ol;
ne.invalidDate = al;
ne.ordinal = cl;
ne.preparse = si;
ne.postformat = si;
ne.relativeTime = fl;
ne.pastFuture = hl;
ne.set = Xa;
ne.eras = Vc;
ne.erasParse = Uc;
ne.erasConvertYear = Gc;
ne.erasAbbrRegex = qc;
ne.erasNameRegex = Zc;
ne.erasNarrowRegex = Kc;
ne.months = bl;
ne.monthsShort = Ol;
ne.monthsParse = Rl;
ne.monthsRegex = Nl;
ne.monthsShortRegex = El;
ne.week = Hl;
ne.firstDayOfYear = Al;
ne.firstDayOfWeek = Fl;
ne.weekdays = Kl;
ne.weekdaysMin = Ql;
ne.weekdaysShort = Jl;
ne.weekdaysParse = eu;
ne.weekdaysRegex = su;
ne.weekdaysShortRegex = ou;
ne.weekdaysMinRegex = iu;
ne.isPM = lu;
ne.meridiem = du;
function Bn(e, t, n, r) {
  var s = St(), o = lt().set(r, t);
  return s[n](o, e);
}
function oi(e, t, n) {
  if (yt(e) && (t = e, e = void 0), e = e || "", t != null)
    return Bn(e, t, n, "month");
  var r, s = [];
  for (r = 0; r < 12; r++)
    s[r] = Bn(e, r, n, "month");
  return s;
}
function as(e, t, n, r) {
  typeof e == "boolean" ? (yt(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, yt(t) && (n = t, t = void 0), t = t || "");
  var s = St(), o = e ? s._week.dow : 0, i, a = [];
  if (n != null)
    return Bn(t, (n + o) % 7, r, "day");
  for (i = 0; i < 7; i++)
    a[i] = Bn(t, (i + o) % 7, r, "day");
  return a;
}
function gd(e, t) {
  return oi(e, t, "months");
}
function _d(e, t) {
  return oi(e, t, "monthsShort");
}
function yd(e, t, n) {
  return as(e, t, n, "weekdays");
}
function Sd(e, t, n) {
  return as(e, t, n, "weekdaysShort");
}
function wd(e, t, n) {
  return as(e, t, n, "weekdaysMin");
}
bt("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = j(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
I.lang = Ze(
  "moment.lang is deprecated. Use moment.locale instead.",
  bt
);
I.langData = Ze(
  "moment.langData is deprecated. Use moment.localeData instead.",
  St
);
var dt = Math.abs;
function vd() {
  var e = this._data;
  return this._milliseconds = dt(this._milliseconds), this._days = dt(this._days), this._months = dt(this._months), e.milliseconds = dt(e.milliseconds), e.seconds = dt(e.seconds), e.minutes = dt(e.minutes), e.hours = dt(e.hours), e.months = dt(e.months), e.years = dt(e.years), this;
}
function ii(e, t, n, r) {
  var s = nt(t, n);
  return e._milliseconds += r * s._milliseconds, e._days += r * s._days, e._months += r * s._months, e._bubble();
}
function xd(e, t) {
  return ii(this, e, t, 1);
}
function Td(e, t) {
  return ii(this, e, t, -1);
}
function Ws(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function kd() {
  var e = this._milliseconds, t = this._days, n = this._months, r = this._data, s, o, i, a, l;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += Ws(Rr(n) + t) * 864e5, t = 0, n = 0), r.milliseconds = e % 1e3, s = $e(e / 1e3), r.seconds = s % 60, o = $e(s / 60), r.minutes = o % 60, i = $e(o / 60), r.hours = i % 24, t += $e(i / 24), l = $e(ai(t)), n += l, t -= Ws(Rr(l)), a = $e(n / 12), n %= 12, r.days = t, r.months = n, r.years = a, this;
}
function ai(e) {
  return e * 4800 / 146097;
}
function Rr(e) {
  return e * 146097 / 4800;
}
function Id(e) {
  if (!this.isValid())
    return NaN;
  var t, n, r = this._milliseconds;
  if (e = qe(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, n = this._months + ai(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(Rr(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Md() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + j(this._months / 12) * 31536e6 : NaN;
}
function wt(e) {
  return function() {
    return this.as(e);
  };
}
var Dd = wt("ms"), bd = wt("s"), Od = wt("m"), Cd = wt("h"), Rd = wt("d"), Yd = wt("w"), Ed = wt("M"), Nd = wt("Q"), Pd = wt("y");
function Ld() {
  return nt(this);
}
function Hd(e) {
  return e = qe(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Vt(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Wd = Vt("milliseconds"), Fd = Vt("seconds"), Ad = Vt("minutes"), Vd = Vt("hours"), Ud = Vt("days"), Gd = Vt("months"), zd = Vt("years");
function Bd() {
  return $e(this.days() / 7);
}
var ft = Math.round, Bt = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function $d(e, t, n, r, s) {
  return s.relativeTime(t || 1, !!n, e, r);
}
function jd(e, t, n, r) {
  var s = nt(e).abs(), o = ft(s.as("s")), i = ft(s.as("m")), a = ft(s.as("h")), l = ft(s.as("d")), u = ft(s.as("M")), c = ft(s.as("w")), p = ft(s.as("y")), _ = o <= n.ss && ["s", o] || o < n.s && ["ss", o] || i <= 1 && ["m"] || i < n.m && ["mm", i] || a <= 1 && ["h"] || a < n.h && ["hh", a] || l <= 1 && ["d"] || l < n.d && ["dd", l];
  return n.w != null && (_ = _ || c <= 1 && ["w"] || c < n.w && ["ww", c]), _ = _ || u <= 1 && ["M"] || u < n.M && ["MM", u] || p <= 1 && ["y"] || ["yy", p], _[2] = t, _[3] = +e > 0, _[4] = r, $d.apply(null, _);
}
function Zd(e) {
  return e === void 0 ? ft : typeof e == "function" ? (ft = e, !0) : !1;
}
function qd(e, t) {
  return Bt[e] === void 0 ? !1 : t === void 0 ? Bt[e] : (Bt[e] = t, e === "s" && (Bt.ss = t - 1), !0);
}
function Kd(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = Bt, s, o;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (r = Object.assign({}, Bt, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), s = this.localeData(), o = jd(this, !n, r, s), n && (o = s.pastFuture(+this, o)), s.postformat(o);
}
var Sr = Math.abs;
function Gt(e) {
  return (e > 0) - (e < 0) || +e;
}
function lr() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Sr(this._milliseconds) / 1e3, t = Sr(this._days), n = Sr(this._months), r, s, o, i, a = this.asSeconds(), l, u, c, p;
  return a ? (r = $e(e / 60), s = $e(r / 60), e %= 60, r %= 60, o = $e(n / 12), n %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = a < 0 ? "-" : "", u = Gt(this._months) !== Gt(a) ? "-" : "", c = Gt(this._days) !== Gt(a) ? "-" : "", p = Gt(this._milliseconds) !== Gt(a) ? "-" : "", l + "P" + (o ? u + o + "Y" : "") + (n ? u + n + "M" : "") + (t ? c + t + "D" : "") + (s || r || e ? "T" : "") + (s ? p + s + "H" : "") + (r ? p + r + "M" : "") + (e ? p + i + "S" : "")) : "P0D";
}
var X = ir.prototype;
X.isValid = Uu;
X.abs = vd;
X.add = xd;
X.subtract = Td;
X.as = Id;
X.asMilliseconds = Dd;
X.asSeconds = bd;
X.asMinutes = Od;
X.asHours = Cd;
X.asDays = Rd;
X.asWeeks = Yd;
X.asMonths = Ed;
X.asQuarters = Nd;
X.asYears = Pd;
X.valueOf = Md;
X._bubble = kd;
X.clone = Ld;
X.get = Hd;
X.milliseconds = Wd;
X.seconds = Fd;
X.minutes = Ad;
X.hours = Vd;
X.days = Ud;
X.weeks = Bd;
X.months = Gd;
X.years = zd;
X.humanize = Kd;
X.toISOString = lr;
X.toString = lr;
X.toJSON = lr;
X.locale = qo;
X.localeData = Jo;
X.toIsoString = Ze(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  lr
);
X.lang = Ko;
L("X", 0, 0, "unix");
L("x", 0, 0, "valueOf");
O("x", nr);
O("X", yl);
le("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
le("x", function(e, t, n) {
  n._d = new Date(j(e));
});
//! moment.js
I.version = "2.29.4";
Ja(ce);
I.fn = S;
I.min = Wu;
I.max = Fu;
I.now = Au;
I.utc = lt;
I.unix = md;
I.months = gd;
I.isDate = wn;
I.locale = bt;
I.invalid = Jn;
I.duration = nt;
I.isMoment = tt;
I.weekdays = yd;
I.parseZone = pd;
I.localeData = St;
I.isDuration = Nn;
I.monthsShort = _d;
I.weekdaysMin = wd;
I.defineLocale = Xr;
I.updateLocale = pu;
I.locales = gu;
I.weekdaysShort = Sd;
I.normalizeUnits = qe;
I.relativeTimeRounding = Zd;
I.relativeTimeThreshold = qd;
I.calendarFormat = dc;
I.prototype = S;
I.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function rh() {
  var Et;
  const e = cr(null), t = cr([]), [n, r] = di(-1), s = cr(null), {
    tokenBuy: o,
    tokenSell: i,
    setTokenSell: a,
    setTokenBuy: l,
    flipTokens: u,
    setSellAmount: c,
    setLimitPrice: p,
    setLimitMultiples: _,
    orderType: D
  } = kn((C) => C.swapSlice), {
    open: M,
    searchInput: d,
    swapType: x,
    unverifiedTokenList: h,
    supportedTokens: m,
    setSearchInput: T,
    toggleModal: Y,
    closeModal: g,
    setAdaUsdPrice: f,
    setTokenList: b,
    setUnverifiedTokenList: E,
    callbackSelectedToken: P
  } = kn((C) => C.tokenSearchSlice), {
    userAddress: W,
    addressList: U,
    setUserTokens: K,
    updateBalance: ie,
    setUserOrders: F,
    userTokens: G,
    balance: se
  } = kn((C) => C.walletSlice), { isHideSmallBalances: _e, setIsHideSmallBalances: Ye } = kn(
    (C) => C.globalSettingsSlice
  ), { saveSettings: Ie } = yi(), { isMobile: Me } = mi(), Le = (C) => {
    if (C.target.value !== "/") {
      if (C.target.value === ".") {
        He();
        return;
      }
      T(C.target.value), r(-1);
    }
  }, He = () => {
    const C = !_e;
    Ye(C), Ie({ isHideSmallBalances: C });
  }, ct = (C) => /^[a-zA-Z0-9]{56}$/.test(C);
  tn(
    ["tokenListUnverified", d],
    async () => {
      if (ct(d)) {
        const { data: C } = await Mn.get("/swap/tokens", {
          params: { verified: !1, query: d }
        });
        return E(C), C;
      }
      return [];
    },
    {
      enabled: ct(d)
    }
  );
  const { data: vt } = tn(
    ["tokenList"],
    async () => {
      const { data: C } = await Mn.get("/swap/tokens");
      return b(C), C;
    },
    {
      refetchInterval: 3e4
    }
  );
  tn(
    ["userBalance", U, W],
    async () => {
      if (W && (U == null ? void 0 : U.length) > 0) {
        const { balance: C, tokens: N } = await _i(U);
        ie(C), K(N || []);
      }
      return !0;
    },
    {
      refetchInterval: 5e3,
      enabled: !!W,
      refetchOnWindowFocus: !0
    }
  ), tn(
    ["userOrders", W],
    async () => {
      const { data: C } = await Mn.get(`/swap/orders/${W}`);
      return F(
        C.sort((N, z) => I(N.last_update).isBefore(z.last_update) ? 1 : I(N.last_update).isAfter(z.last_update) ? -1 : 0)
      ), C;
    },
    {
      enabled: !!W,
      refetchInterval: 3e3,
      refetchOnWindowFocus: !0
    }
  ), tn(
    ["usdPrice"],
    async () => {
      const { data: C } = await Mn.get("/swap/adaValue");
      return console.log("usdPrice", C), f(C), C;
    },
    {
      refetchInterval: 3e5
    }
  ), fs(() => {
    r(-1);
  }, [x]);
  const w = dr(() => {
    if (!vt)
      return [];
    const C = vt.map((z) => {
      const J = G == null ? void 0 : G.find(
        (Ee) => Ee.token_id === z.token_id
      );
      return J ? (J == null ? void 0 : J.amount) && J.ada_value < 5 && _e ? z : {
        ...z,
        amount: J.amount,
        ada_value: J.ada_value
      } : z;
    }).sort((z, J) => !z.ada_value && J.ada_value ? 1 : z.ada_value && !J.ada_value || z.ada_value > J.ada_value ? -1 : z.ada_value < J.ada_value ? 1 : In[z.token_id] && !In[J.token_id] ? -1 : In[J.token_id] && !In[z.token_id] ? 1 : z.token_ascii < J.token_ascii ? -1 : z.token_ascii > J.token_ascii ? 1 : 0), N = [
      { ...Ke, amount: se, ada_value: se },
      ...C
    ].filter(
      (z) => {
        var J, Ee, rt;
        return (((J = z == null ? void 0 : z.token_ascii) == null ? void 0 : J.toLowerCase().includes(d.toLowerCase())) || ((Ee = z == null ? void 0 : z.token_policy) == null ? void 0 : Ee.toLowerCase().includes(d.toLowerCase())) || ((rt = z == null ? void 0 : z.ticker) == null ? void 0 : rt.toLowerCase().includes(d.toLowerCase()))) && // If swapType basket exclude CARDAON_TOKEN from search
        !(x === "BASKET" && z.token_id === Ke.token_id);
      }
      // Exclude CARDANO_TOKEN from search when swapType is 'SWAP'
      // !(swapType === "SWAP" && token.token_policy === CARDANO_TOKEN.token_policy) &&
      // !(swapType === "BUY" && token.token_policy === CARDANO_TOKEN.token_policy) &&
      // !(swapType === "SELL" && token.token_policy === CARDANO_TOKEN.token_policy)
    ).filter((z) => m.length === 0 ? !0 : m.includes(z.token_id)).sort((z, J) => {
      if (!d)
        return 0;
      const Ee = z.ticker.toLowerCase(), rt = J.ticker.toLowerCase();
      return Ee === d.toLowerCase() ? -1 : rt === d.toLowerCase() ? 1 : 0;
    });
    return N.length < 5 && N.forEach((z) => {
      const J = new URLSearchParams(window.location.search);
      J.set("tokenBuy", z.token_id), J.set("tokenSell", Ke.token_id), J.set("tokenSell", z.token_id), J.set("tokenBuy", Ke.token_id);
    }), h && h.length > 0 && ct(d) ? h : N;
  }, [
    d,
    x,
    o,
    i,
    vt,
    G,
    W,
    _e
  ]), Z = () => {
    u(), g();
  }, re = (C) => {
    if (D === "STOP_LOSS") {
      l(Ke), a(C), g();
      return;
    }
    try {
      switch (x) {
        case "SELL":
          pe(C);
          break;
        case "BUY":
          Te(C);
          break;
        case "BASKET":
          We(C);
          break;
        default:
          throw new Error("Invalid swap type");
      }
      g();
    } catch {
    }
  }, pe = (C) => {
    if ((o == null ? void 0 : o.token_id) === C.token_id)
      return Z();
    (o == null ? void 0 : o.token_id) !== Ke.token_id && C.token_id !== Ke.token_id && l(Ke), c(0), p(0), _(0), a(C);
  }, Te = (C) => {
    if ((i == null ? void 0 : i.token_id) === C.token_id)
      return Z();
    (i == null ? void 0 : i.token_id) !== Ke.token_id && C.token_id !== Ke.token_id && a(Ke), p(0), _(0), l(C);
  }, We = (C) => {
    P(C);
  };
  fs(() => {
    const C = (N) => {
      var z, J, Ee, rt;
      if (N.key === "Escape") {
        g();
        return;
      }
      if (N.key === "/") {
        (z = e.current) == null || z.focus(), Y();
        return;
      }
      if (M && N.key.match(/^[a-zA-Z0-9]$/)) {
        (J = e.current) == null || J.focus();
        return;
      }
      if (M && N.key === "Enter") {
        if (N.preventDefault(), n !== -1)
          return re(w[n]);
        if (w[0])
          return re(w[0]);
      }
      M && (N.key === "ArrowDown" || N.key === "Tab" && !N.shiftKey) ? (N.preventDefault(), n >= w.length - 1 ? r(0) : r((kt) => kt + 1), (Ee = t.current[n]) == null || Ee.scrollIntoView({ block: "nearest" })) : M && (N.key === "ArrowUp" || N.key === "Tab" && N.shiftKey) && (N.preventDefault(), n <= 0 ? r(w.length - 1) : r((kt) => kt - 1), (rt = t.current[n]) == null || rt.scrollIntoView({ block: "nearest" }));
    };
    return document.addEventListener("keydown", C), () => {
      document.removeEventListener("keydown", C);
    };
  }, [M, w, n, re, g]);
  const we = dr(() => _e ? /* @__PURE__ */ ye(
    wi,
    {
      className: "dhs-top-3 dhs-text-mainText",
      width: 18,
      height: 18
    }
  ) : /* @__PURE__ */ ye(
    Si,
    {
      className: "dhs-top-3 dhs-text-mainText",
      width: 18,
      height: 18
    }
  ), [_e]), Tt = dr(() => {
    var N;
    return (((N = document.getElementById("dexhunter-root")) == null ? void 0 : N.offsetHeight) || 450) - 200;
  }, [(Et = document.getElementById("dexhunter-root")) == null ? void 0 : Et.offsetHeight]);
  return /* @__PURE__ */ ye(xi, { open: M, onOpenChange: Y, children: /* @__PURE__ */ Fe(
    Ti,
    {
      side: "top",
      className: " dhs-mx-0 dhs-translate-y-0 dhs-bottom-0 dhs-rounded-[26px]",
      ref: s,
      children: [
        /* @__PURE__ */ Fe("div", { className: "dhs-px-3 @sm/appRoot:dhs-px-5 @md/appRoot:dhs-pb-6 @sm/appRoot:dhs-flex @sm/appRoot:dhs-flex-col", children: [
          /* @__PURE__ */ Fe("div", { className: "dhs-flex dhs-pb-3 dhs-pt-3 @md/appRoot:dhs-pb-5 @sm/appRoot:dhs-mx-5 @sm/appRoot:dhs-pb-[14px] dhs-justify-center dhs-items-center", children: [
            /* @__PURE__ */ ye(
              "div",
              {
                onClick: () => g(),
                className: "dhs-flex dhs-justify-center dhs-items-center dhs-w-8 dhs-h-8 dhs-rounded-xl dhs-bg-containers dhs-cursor-pointer dhs-absolute dhs-right-3 @md/appRoot:dhs-right-7 @sm/appRoot:dhs-right-5",
                children: /* @__PURE__ */ ye(pi, { className: "dhs-text-mainText dhs-flex dhs-w-[12px] dhs-h-[12px]" })
              }
            ),
            /* @__PURE__ */ ye("div", { className: "dhs-flex", children: /* @__PURE__ */ Fe("div", { className: "dhs-flex dhs-items-center dhs-text-base @md/appRoot:dhs-text-lg @sm/appRoot:dhs-text-base dhs-text-mainText dhs-font-proximaBold", children: [
              "Select a token",
              /* @__PURE__ */ Fe("span", { className: "sm:dhs-hidden dhs-inline", children: [
                " to ",
                x.toLowerCase()
              ] })
            ] }) }),
            /* @__PURE__ */ ye(
              "div",
              {
                onClick: He,
                className: "dhs-flex dhs-justify-center dhs-items-center dhs-w-8 dhs-h-8 dhs-rounded-xl dhs-bg-containers dhs-cursor-pointer dhs-absolute dhs-left-3 @md/appRoot:dhs-left-7 @sm/appRoot:dhs-left-5",
                children: /* @__PURE__ */ ye(
                  gi,
                  {
                    trigger: we,
                    content: _e ? "Show Small Balances" : "Hide Small Balances",
                    contentClass: "dhs-text-mainText"
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ Fe("div", { className: "dhs-relative dhs-grid dhs-gap-4 sm:dhs-mx-5", children: [
            /* @__PURE__ */ ye("div", { className: "dhs-absolute dhs-inset-y-0 dhs-left-0 dhs-flex dhs-items-center dhs-pl-5 dhs-pointer-events-none", children: /* @__PURE__ */ ye(
              vi,
              {
                className: "dhs-top-3 dhs-text-mainText",
                width: 14,
                height: 14
              }
            ) }),
            /* @__PURE__ */ ye(
              ci,
              {
                type: "search",
                ref: e,
                id: "token",
                value: d,
                className: "dhs-col-span-3 dhs-block dhs-h-12 @md/appRoot:dhs-h-[60px] @sm/appRoot:dhs-h-[50px] dhs-p-4 dhs-pl-12 dhs-text-base sm:dhs-text-sm dhs-text-mainText dhs-font-proximaSemiBold dhs-border-2 focus-visible:dhs-ring-0 focus-visible:dhs-ring-offset-0 dhs-border-subText dhs-rounded-xl dhs-bg-containers focus:dhs-ring-accent focus:dhs-border-accent placeholder-shown:dhs-text-base placeholder:dhs-text-subText placeholder:dhs-font-proximaSemiBold",
                placeholder: "Search by name or policy",
                onChange: Le,
                autoFocus: !Me
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ ye("div", { className: "dhs-pt-1 sm:dhs-pt-0 sm:dhs-border-t-[1px] sm:dhs-border-t-gray-105", children: /* @__PURE__ */ ye(
          La,
          {
            style: { height: Tt },
            totalCount: w.length,
            itemContent: (C) => {
              const N = w[C];
              return /* @__PURE__ */ Fe(
                "div",
                {
                  ref: (z) => t.current[C + 0] = z,
                  tabIndex: 0,
                  className: hi(
                    "dhs-px-3 dhs-py-1 @sm/appRoot:dhs-px-7 @sm/appRoot:dhs-py-2.5 dhs-flex dhs-items-center dhs-justify-between dark:dhs-border-gray-800 dhs-cursor-pointer hover:dhs-bg-containers",
                    C === n ? "dhs-bg-containers" : ""
                    // index === 0 ? "@sm/appRoot:dhs-pt-[15px]" : "",
                  ),
                  onFocus: () => r(C),
                  onBlur: () => r(-1),
                  onClick: () => re(N),
                  children: [
                    /* @__PURE__ */ Fe("div", { className: "dhs-flex dhs-items-center dhs-gap-2 @md/appRoot:dhs-gap-4", children: [
                      /* @__PURE__ */ ye(
                        ms,
                        {
                          token: N,
                          isVerified: o == null ? void 0 : o.is_verified,
                          className: "dhs-w-[28px] dhs-h-[28px] @md/appRoot:dhs-hidden",
                          size: 28,
                          verifiedClass: "dhs-w-2.5 dhs-h-2.5"
                        }
                      ),
                      /* @__PURE__ */ ye(
                        ms,
                        {
                          token: N,
                          isVerified: o == null ? void 0 : o.is_verified,
                          className: "dhs-hidden dhs-w-[36px] dhs-h-[36px] @md/appRoot:dhs-block",
                          size: 36
                        }
                      ),
                      /* @__PURE__ */ Fe("div", { className: "dhs-flex dhs-flex-col dhs-leading-none dhs-gap-1", children: [
                        /* @__PURE__ */ ye("span", { className: "dhs-text-base dhs-leading-none dhs-font-proximaSemiBold dhs-text-mainText sm:dhs-w-[125px]", children: N.token_ascii }),
                        /* @__PURE__ */ ye("span", { className: "dhs-text-sm dhs-leading-none dhs-text-subText dhs-font-proximaMedium", children: N == null ? void 0 : N.ticker })
                      ] })
                    ] }),
                    /* @__PURE__ */ ye("div", { className: "dhs-flex dhs-items-center dhs-relative", children: /* @__PURE__ */ Fe("div", { className: "dhs-flex dhs-flex-col dhs-leading-none @md/appRoot:dhs-gap-2", children: [
                      !!N.amount && /* @__PURE__ */ Fe("div", { className: "dhs-flex dhs-gap-1 dhs-text-md dhs-font-proximaSemiBold dhs-justify-end", children: [
                        /* @__PURE__ */ ye("span", { className: "dhs-text-mainText", children: hs(N.amount || 0) }),
                        /* @__PURE__ */ ye("span", { children: N == null ? void 0 : N.ticker })
                      ] }),
                      !!N.ada_value && /* @__PURE__ */ Fe("span", { className: "dhs-text-sm dhs-text-subText dhs-font-proximaMedium dhs-flex dhs-items-center dhs-justify-end", children: [
                        /* @__PURE__ */ ye(ki, { width: 12, height: 12 }),
                        /* @__PURE__ */ Fe("span", { children: [
                          hs(N.ada_value || 0),
                          " ADA"
                        ] })
                      ] })
                    ] }) })
                  ]
                },
                N == null ? void 0 : N.token_ascii
              );
            }
          }
        ) })
      ]
    }
  ) });
}
export {
  rh as default
};
